import { Component, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconActivityComponent = /** @class */ (function () {
    function IconActivityComponent() {
    }
    IconActivityComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-activity',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-activity\">\n    <polyline points=\"22 12 18 12 15 21 9 3 6 12 2 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconActivityComponent;
}());
var IconActivity = /** @class */ (function () {
    function IconActivity() {
    }
    IconActivity.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconActivityComponent],
                    exports: [IconActivityComponent]
                },] }
    ];
    return IconActivity;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAirplayComponent = /** @class */ (function () {
    function IconAirplayComponent() {
    }
    IconAirplayComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-airplay',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-airplay\">\n    <path d=\"M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1\"></path><polygon points=\"12 15 17 21 7 21 12 15\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAirplayComponent;
}());
var IconAirplay = /** @class */ (function () {
    function IconAirplay() {
    }
    IconAirplay.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAirplayComponent],
                    exports: [IconAirplayComponent]
                },] }
    ];
    return IconAirplay;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlertCircleComponent = /** @class */ (function () {
    function IconAlertCircleComponent() {
    }
    IconAlertCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-alert-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-alert-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlertCircleComponent;
}());
var IconAlertCircle = /** @class */ (function () {
    function IconAlertCircle() {
    }
    IconAlertCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlertCircleComponent],
                    exports: [IconAlertCircleComponent]
                },] }
    ];
    return IconAlertCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlertOctagonComponent = /** @class */ (function () {
    function IconAlertOctagonComponent() {
    }
    IconAlertOctagonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-alert-octagon',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-alert-octagon\">\n    <polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlertOctagonComponent;
}());
var IconAlertOctagon = /** @class */ (function () {
    function IconAlertOctagon() {
    }
    IconAlertOctagon.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlertOctagonComponent],
                    exports: [IconAlertOctagonComponent]
                },] }
    ];
    return IconAlertOctagon;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlertTriangleComponent = /** @class */ (function () {
    function IconAlertTriangleComponent() {
    }
    IconAlertTriangleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-alert-triangle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-alert-triangle\">\n    <path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\"></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"13\"></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"17\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlertTriangleComponent;
}());
var IconAlertTriangle = /** @class */ (function () {
    function IconAlertTriangle() {
    }
    IconAlertTriangle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlertTriangleComponent],
                    exports: [IconAlertTriangleComponent]
                },] }
    ];
    return IconAlertTriangle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlignCenterComponent = /** @class */ (function () {
    function IconAlignCenterComponent() {
    }
    IconAlignCenterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-align-center',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-align-center\">\n    <line x1=\"18\" y1=\"10\" x2=\"6\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"18\" y1=\"18\" x2=\"6\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlignCenterComponent;
}());
var IconAlignCenter = /** @class */ (function () {
    function IconAlignCenter() {
    }
    IconAlignCenter.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlignCenterComponent],
                    exports: [IconAlignCenterComponent]
                },] }
    ];
    return IconAlignCenter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlignJustifyComponent = /** @class */ (function () {
    function IconAlignJustifyComponent() {
    }
    IconAlignJustifyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-align-justify',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-align-justify\">\n    <line x1=\"21\" y1=\"10\" x2=\"3\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"21\" y1=\"18\" x2=\"3\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlignJustifyComponent;
}());
var IconAlignJustify = /** @class */ (function () {
    function IconAlignJustify() {
    }
    IconAlignJustify.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlignJustifyComponent],
                    exports: [IconAlignJustifyComponent]
                },] }
    ];
    return IconAlignJustify;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlignLeftComponent = /** @class */ (function () {
    function IconAlignLeftComponent() {
    }
    IconAlignLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-align-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-align-left\">\n    <line x1=\"17\" y1=\"10\" x2=\"3\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"17\" y1=\"18\" x2=\"3\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlignLeftComponent;
}());
var IconAlignLeft = /** @class */ (function () {
    function IconAlignLeft() {
    }
    IconAlignLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlignLeftComponent],
                    exports: [IconAlignLeftComponent]
                },] }
    ];
    return IconAlignLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAlignRightComponent = /** @class */ (function () {
    function IconAlignRightComponent() {
    }
    IconAlignRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-align-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-align-right\">\n    <line x1=\"21\" y1=\"10\" x2=\"7\" y2=\"10\"></line><line x1=\"21\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"21\" y1=\"14\" x2=\"3\" y2=\"14\"></line><line x1=\"21\" y1=\"18\" x2=\"7\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAlignRightComponent;
}());
var IconAlignRight = /** @class */ (function () {
    function IconAlignRight() {
    }
    IconAlignRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAlignRightComponent],
                    exports: [IconAlignRightComponent]
                },] }
    ];
    return IconAlignRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAnchorComponent = /** @class */ (function () {
    function IconAnchorComponent() {
    }
    IconAnchorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-anchor',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-anchor\">\n    <circle cx=\"12\" cy=\"5\" r=\"3\"></circle><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"8\"></line><path d=\"M5 12H2a10 10 0 0 0 20 0h-3\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAnchorComponent;
}());
var IconAnchor = /** @class */ (function () {
    function IconAnchor() {
    }
    IconAnchor.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAnchorComponent],
                    exports: [IconAnchorComponent]
                },] }
    ];
    return IconAnchor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconApertureComponent = /** @class */ (function () {
    function IconApertureComponent() {
    }
    IconApertureComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-aperture',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-aperture\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"14.31\" y1=\"8\" x2=\"20.05\" y2=\"17.94\"></line><line x1=\"9.69\" y1=\"8\" x2=\"21.17\" y2=\"8\"></line><line x1=\"7.38\" y1=\"12\" x2=\"13.12\" y2=\"2.06\"></line><line x1=\"9.69\" y1=\"16\" x2=\"3.95\" y2=\"6.06\"></line><line x1=\"14.31\" y1=\"16\" x2=\"2.83\" y2=\"16\"></line><line x1=\"16.62\" y1=\"12\" x2=\"10.88\" y2=\"21.94\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconApertureComponent;
}());
var IconAperture = /** @class */ (function () {
    function IconAperture() {
    }
    IconAperture.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconApertureComponent],
                    exports: [IconApertureComponent]
                },] }
    ];
    return IconAperture;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArchiveComponent = /** @class */ (function () {
    function IconArchiveComponent() {
    }
    IconArchiveComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-archive',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-archive\">\n    <polyline points=\"21 8 21 21 3 21 3 8\"></polyline><rect x=\"1\" y=\"3\" width=\"22\" height=\"5\"></rect><line x1=\"10\" y1=\"12\" x2=\"14\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArchiveComponent;
}());
var IconArchive = /** @class */ (function () {
    function IconArchive() {
    }
    IconArchive.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArchiveComponent],
                    exports: [IconArchiveComponent]
                },] }
    ];
    return IconArchive;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowDownCircleComponent = /** @class */ (function () {
    function IconArrowDownCircleComponent() {
    }
    IconArrowDownCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-down-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-down-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"8 12 12 16 16 12\"></polyline><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowDownCircleComponent;
}());
var IconArrowDownCircle = /** @class */ (function () {
    function IconArrowDownCircle() {
    }
    IconArrowDownCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowDownCircleComponent],
                    exports: [IconArrowDownCircleComponent]
                },] }
    ];
    return IconArrowDownCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowDownLeftComponent = /** @class */ (function () {
    function IconArrowDownLeftComponent() {
    }
    IconArrowDownLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-down-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-down-left\">\n    <line x1=\"17\" y1=\"7\" x2=\"7\" y2=\"17\"></line><polyline points=\"17 17 7 17 7 7\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowDownLeftComponent;
}());
var IconArrowDownLeft = /** @class */ (function () {
    function IconArrowDownLeft() {
    }
    IconArrowDownLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowDownLeftComponent],
                    exports: [IconArrowDownLeftComponent]
                },] }
    ];
    return IconArrowDownLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowDownRightComponent = /** @class */ (function () {
    function IconArrowDownRightComponent() {
    }
    IconArrowDownRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-down-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-down-right\">\n    <line x1=\"7\" y1=\"7\" x2=\"17\" y2=\"17\"></line><polyline points=\"17 7 17 17 7 17\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowDownRightComponent;
}());
var IconArrowDownRight = /** @class */ (function () {
    function IconArrowDownRight() {
    }
    IconArrowDownRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowDownRightComponent],
                    exports: [IconArrowDownRightComponent]
                },] }
    ];
    return IconArrowDownRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowDownComponent = /** @class */ (function () {
    function IconArrowDownComponent() {
    }
    IconArrowDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-down\">\n    <line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"></line><polyline points=\"19 12 12 19 5 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowDownComponent;
}());
var IconArrowDown = /** @class */ (function () {
    function IconArrowDown() {
    }
    IconArrowDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowDownComponent],
                    exports: [IconArrowDownComponent]
                },] }
    ];
    return IconArrowDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowLeftCircleComponent = /** @class */ (function () {
    function IconArrowLeftCircleComponent() {
    }
    IconArrowLeftCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-left-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-left-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 8 8 12 12 16\"></polyline><line x1=\"16\" y1=\"12\" x2=\"8\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowLeftCircleComponent;
}());
var IconArrowLeftCircle = /** @class */ (function () {
    function IconArrowLeftCircle() {
    }
    IconArrowLeftCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowLeftCircleComponent],
                    exports: [IconArrowLeftCircleComponent]
                },] }
    ];
    return IconArrowLeftCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowLeftComponent = /** @class */ (function () {
    function IconArrowLeftComponent() {
    }
    IconArrowLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-left\">\n    <line x1=\"19\" y1=\"12\" x2=\"5\" y2=\"12\"></line><polyline points=\"12 19 5 12 12 5\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowLeftComponent;
}());
var IconArrowLeft = /** @class */ (function () {
    function IconArrowLeft() {
    }
    IconArrowLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowLeftComponent],
                    exports: [IconArrowLeftComponent]
                },] }
    ];
    return IconArrowLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowRightCircleComponent = /** @class */ (function () {
    function IconArrowRightCircleComponent() {
    }
    IconArrowRightCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-right-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-right-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 16 16 12 12 8\"></polyline><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowRightCircleComponent;
}());
var IconArrowRightCircle = /** @class */ (function () {
    function IconArrowRightCircle() {
    }
    IconArrowRightCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowRightCircleComponent],
                    exports: [IconArrowRightCircleComponent]
                },] }
    ];
    return IconArrowRightCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowRightComponent = /** @class */ (function () {
    function IconArrowRightComponent() {
    }
    IconArrowRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-right\">\n    <line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line><polyline points=\"12 5 19 12 12 19\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowRightComponent;
}());
var IconArrowRight = /** @class */ (function () {
    function IconArrowRight() {
    }
    IconArrowRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowRightComponent],
                    exports: [IconArrowRightComponent]
                },] }
    ];
    return IconArrowRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowUpCircleComponent = /** @class */ (function () {
    function IconArrowUpCircleComponent() {
    }
    IconArrowUpCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-up-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-up-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"16 12 12 8 8 12\"></polyline><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"8\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowUpCircleComponent;
}());
var IconArrowUpCircle = /** @class */ (function () {
    function IconArrowUpCircle() {
    }
    IconArrowUpCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowUpCircleComponent],
                    exports: [IconArrowUpCircleComponent]
                },] }
    ];
    return IconArrowUpCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowUpLeftComponent = /** @class */ (function () {
    function IconArrowUpLeftComponent() {
    }
    IconArrowUpLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-up-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-up-left\">\n    <line x1=\"17\" y1=\"17\" x2=\"7\" y2=\"7\"></line><polyline points=\"7 17 7 7 17 7\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowUpLeftComponent;
}());
var IconArrowUpLeft = /** @class */ (function () {
    function IconArrowUpLeft() {
    }
    IconArrowUpLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowUpLeftComponent],
                    exports: [IconArrowUpLeftComponent]
                },] }
    ];
    return IconArrowUpLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowUpRightComponent = /** @class */ (function () {
    function IconArrowUpRightComponent() {
    }
    IconArrowUpRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-up-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-up-right\">\n    <line x1=\"7\" y1=\"17\" x2=\"17\" y2=\"7\"></line><polyline points=\"7 7 17 7 17 17\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowUpRightComponent;
}());
var IconArrowUpRight = /** @class */ (function () {
    function IconArrowUpRight() {
    }
    IconArrowUpRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowUpRightComponent],
                    exports: [IconArrowUpRightComponent]
                },] }
    ];
    return IconArrowUpRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconArrowUpComponent = /** @class */ (function () {
    function IconArrowUpComponent() {
    }
    IconArrowUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-arrow-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-arrow-up\">\n    <line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"5\"></line><polyline points=\"5 12 12 5 19 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconArrowUpComponent;
}());
var IconArrowUp = /** @class */ (function () {
    function IconArrowUp() {
    }
    IconArrowUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconArrowUpComponent],
                    exports: [IconArrowUpComponent]
                },] }
    ];
    return IconArrowUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAtSignComponent = /** @class */ (function () {
    function IconAtSignComponent() {
    }
    IconAtSignComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-at-sign',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-at-sign\">\n    <circle cx=\"12\" cy=\"12\" r=\"4\"></circle><path d=\"M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAtSignComponent;
}());
var IconAtSign = /** @class */ (function () {
    function IconAtSign() {
    }
    IconAtSign.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAtSignComponent],
                    exports: [IconAtSignComponent]
                },] }
    ];
    return IconAtSign;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconAwardComponent = /** @class */ (function () {
    function IconAwardComponent() {
    }
    IconAwardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-award',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-award\">\n    <circle cx=\"12\" cy=\"8\" r=\"7\"></circle><polyline points=\"8.21 13.89 7 23 12 20 17 23 15.79 13.88\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconAwardComponent;
}());
var IconAward = /** @class */ (function () {
    function IconAward() {
    }
    IconAward.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconAwardComponent],
                    exports: [IconAwardComponent]
                },] }
    ];
    return IconAward;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBarChart2Component = /** @class */ (function () {
    function IconBarChart2Component() {
    }
    IconBarChart2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-bar-chart-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bar-chart-2\">\n    <line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"10\"></line><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\"></line><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBarChart2Component;
}());
var IconBarChart2 = /** @class */ (function () {
    function IconBarChart2() {
    }
    IconBarChart2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBarChart2Component],
                    exports: [IconBarChart2Component]
                },] }
    ];
    return IconBarChart2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBarChartComponent = /** @class */ (function () {
    function IconBarChartComponent() {
    }
    IconBarChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-bar-chart',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bar-chart\">\n    <line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"10\"></line><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"4\"></line><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBarChartComponent;
}());
var IconBarChart = /** @class */ (function () {
    function IconBarChart() {
    }
    IconBarChart.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBarChartComponent],
                    exports: [IconBarChartComponent]
                },] }
    ];
    return IconBarChart;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBatteryChargingComponent = /** @class */ (function () {
    function IconBatteryChargingComponent() {
    }
    IconBatteryChargingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-battery-charging',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-battery-charging\">\n    <path d=\"M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19\"></path><line x1=\"23\" y1=\"13\" x2=\"23\" y2=\"11\"></line><polyline points=\"11 6 7 12 13 12 9 18\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBatteryChargingComponent;
}());
var IconBatteryCharging = /** @class */ (function () {
    function IconBatteryCharging() {
    }
    IconBatteryCharging.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBatteryChargingComponent],
                    exports: [IconBatteryChargingComponent]
                },] }
    ];
    return IconBatteryCharging;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBatteryComponent = /** @class */ (function () {
    function IconBatteryComponent() {
    }
    IconBatteryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-battery',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-battery\">\n    <rect x=\"1\" y=\"6\" width=\"18\" height=\"12\" rx=\"2\" ry=\"2\"></rect><line x1=\"23\" y1=\"13\" x2=\"23\" y2=\"11\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBatteryComponent;
}());
var IconBattery = /** @class */ (function () {
    function IconBattery() {
    }
    IconBattery.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBatteryComponent],
                    exports: [IconBatteryComponent]
                },] }
    ];
    return IconBattery;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBellOffComponent = /** @class */ (function () {
    function IconBellOffComponent() {
    }
    IconBellOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-bell-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bell-off\">\n    <path d=\"M13.73 21a2 2 0 0 1-3.46 0\"></path><path d=\"M18.63 13A17.89 17.89 0 0 1 18 8\"></path><path d=\"M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14\"></path><path d=\"M18 8a6 6 0 0 0-9.33-5\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBellOffComponent;
}());
var IconBellOff = /** @class */ (function () {
    function IconBellOff() {
    }
    IconBellOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBellOffComponent],
                    exports: [IconBellOffComponent]
                },] }
    ];
    return IconBellOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBellComponent = /** @class */ (function () {
    function IconBellComponent() {
    }
    IconBellComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-bell',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bell\">\n    <path d=\"M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9\"></path><path d=\"M13.73 21a2 2 0 0 1-3.46 0\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBellComponent;
}());
var IconBell = /** @class */ (function () {
    function IconBell() {
    }
    IconBell.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBellComponent],
                    exports: [IconBellComponent]
                },] }
    ];
    return IconBell;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBluetoothComponent = /** @class */ (function () {
    function IconBluetoothComponent() {
    }
    IconBluetoothComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-bluetooth',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bluetooth\">\n    <polyline points=\"6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBluetoothComponent;
}());
var IconBluetooth = /** @class */ (function () {
    function IconBluetooth() {
    }
    IconBluetooth.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBluetoothComponent],
                    exports: [IconBluetoothComponent]
                },] }
    ];
    return IconBluetooth;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBoldComponent = /** @class */ (function () {
    function IconBoldComponent() {
    }
    IconBoldComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-bold',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bold\">\n    <path d=\"M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z\"></path><path d=\"M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBoldComponent;
}());
var IconBold = /** @class */ (function () {
    function IconBold() {
    }
    IconBold.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBoldComponent],
                    exports: [IconBoldComponent]
                },] }
    ];
    return IconBold;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBookOpenComponent = /** @class */ (function () {
    function IconBookOpenComponent() {
    }
    IconBookOpenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-book-open',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-book-open\">\n    <path d=\"M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z\"></path><path d=\"M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBookOpenComponent;
}());
var IconBookOpen = /** @class */ (function () {
    function IconBookOpen() {
    }
    IconBookOpen.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBookOpenComponent],
                    exports: [IconBookOpenComponent]
                },] }
    ];
    return IconBookOpen;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBookComponent = /** @class */ (function () {
    function IconBookComponent() {
    }
    IconBookComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-book',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-book\">\n    <path d=\"M4 19.5A2.5 2.5 0 0 1 6.5 17H20\"></path><path d=\"M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBookComponent;
}());
var IconBook = /** @class */ (function () {
    function IconBook() {
    }
    IconBook.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBookComponent],
                    exports: [IconBookComponent]
                },] }
    ];
    return IconBook;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBookmarkComponent = /** @class */ (function () {
    function IconBookmarkComponent() {
    }
    IconBookmarkComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-bookmark',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-bookmark\">\n    <path d=\"M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBookmarkComponent;
}());
var IconBookmark = /** @class */ (function () {
    function IconBookmark() {
    }
    IconBookmark.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBookmarkComponent],
                    exports: [IconBookmarkComponent]
                },] }
    ];
    return IconBookmark;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBoxComponent = /** @class */ (function () {
    function IconBoxComponent() {
    }
    IconBoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-box',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-box\">\n    <path d=\"M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z\"></path><polyline points=\"2.32 6.16 12 11 21.68 6.16\"></polyline><line x1=\"12\" y1=\"22.76\" x2=\"12\" y2=\"11\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBoxComponent;
}());
var IconBox = /** @class */ (function () {
    function IconBox() {
    }
    IconBox.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBoxComponent],
                    exports: [IconBoxComponent]
                },] }
    ];
    return IconBox;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBriefcaseComponent = /** @class */ (function () {
    function IconBriefcaseComponent() {
    }
    IconBriefcaseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-briefcase',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-briefcase\">\n    <rect x=\"2\" y=\"7\" width=\"20\" height=\"14\" rx=\"2\" ry=\"2\"></rect><path d=\"M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconBriefcaseComponent;
}());
var IconBriefcase = /** @class */ (function () {
    function IconBriefcase() {
    }
    IconBriefcase.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconBriefcaseComponent],
                    exports: [IconBriefcaseComponent]
                },] }
    ];
    return IconBriefcase;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCalendarComponent = /** @class */ (function () {
    function IconCalendarComponent() {
    }
    IconCalendarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-calendar',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-calendar\">\n    <rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCalendarComponent;
}());
var IconCalendar = /** @class */ (function () {
    function IconCalendar() {
    }
    IconCalendar.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCalendarComponent],
                    exports: [IconCalendarComponent]
                },] }
    ];
    return IconCalendar;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCameraOffComponent = /** @class */ (function () {
    function IconCameraOffComponent() {
    }
    IconCameraOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-camera-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-camera-off\">\n    <line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line><path d=\"M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCameraOffComponent;
}());
var IconCameraOff = /** @class */ (function () {
    function IconCameraOff() {
    }
    IconCameraOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCameraOffComponent],
                    exports: [IconCameraOffComponent]
                },] }
    ];
    return IconCameraOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCameraComponent = /** @class */ (function () {
    function IconCameraComponent() {
    }
    IconCameraComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-camera',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-camera\">\n    <path d=\"M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z\"></path><circle cx=\"12\" cy=\"13\" r=\"4\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCameraComponent;
}());
var IconCamera = /** @class */ (function () {
    function IconCamera() {
    }
    IconCamera.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCameraComponent],
                    exports: [IconCameraComponent]
                },] }
    ];
    return IconCamera;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCastComponent = /** @class */ (function () {
    function IconCastComponent() {
    }
    IconCastComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cast',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cast\">\n    <path d=\"M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6\"></path><line x1=\"2\" y1=\"20\" x2=\"2\" y2=\"20\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCastComponent;
}());
var IconCast = /** @class */ (function () {
    function IconCast() {
    }
    IconCast.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCastComponent],
                    exports: [IconCastComponent]
                },] }
    ];
    return IconCast;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCheckCircleComponent = /** @class */ (function () {
    function IconCheckCircleComponent() {
    }
    IconCheckCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-check-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-check-circle\">\n    <path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\"></path><polyline points=\"22 4 12 14.01 9 11.01\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCheckCircleComponent;
}());
var IconCheckCircle = /** @class */ (function () {
    function IconCheckCircle() {
    }
    IconCheckCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCheckCircleComponent],
                    exports: [IconCheckCircleComponent]
                },] }
    ];
    return IconCheckCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCheckSquareComponent = /** @class */ (function () {
    function IconCheckSquareComponent() {
    }
    IconCheckSquareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-check-square',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-check-square\">\n    <polyline points=\"9 11 12 14 22 4\"></polyline><path d=\"M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCheckSquareComponent;
}());
var IconCheckSquare = /** @class */ (function () {
    function IconCheckSquare() {
    }
    IconCheckSquare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCheckSquareComponent],
                    exports: [IconCheckSquareComponent]
                },] }
    ];
    return IconCheckSquare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCheckComponent = /** @class */ (function () {
    function IconCheckComponent() {
    }
    IconCheckComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-check',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-check\">\n    <polyline points=\"20 6 9 17 4 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCheckComponent;
}());
var IconCheck = /** @class */ (function () {
    function IconCheck() {
    }
    IconCheck.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCheckComponent],
                    exports: [IconCheckComponent]
                },] }
    ];
    return IconCheck;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronDownComponent = /** @class */ (function () {
    function IconChevronDownComponent() {
    }
    IconChevronDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevron-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevron-down\">\n    <polyline points=\"6 9 12 15 18 9\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronDownComponent;
}());
var IconChevronDown = /** @class */ (function () {
    function IconChevronDown() {
    }
    IconChevronDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronDownComponent],
                    exports: [IconChevronDownComponent]
                },] }
    ];
    return IconChevronDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronLeftComponent = /** @class */ (function () {
    function IconChevronLeftComponent() {
    }
    IconChevronLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevron-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevron-left\">\n    <polyline points=\"15 18 9 12 15 6\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronLeftComponent;
}());
var IconChevronLeft = /** @class */ (function () {
    function IconChevronLeft() {
    }
    IconChevronLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronLeftComponent],
                    exports: [IconChevronLeftComponent]
                },] }
    ];
    return IconChevronLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronRightComponent = /** @class */ (function () {
    function IconChevronRightComponent() {
    }
    IconChevronRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevron-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevron-right\">\n    <polyline points=\"9 18 15 12 9 6\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronRightComponent;
}());
var IconChevronRight = /** @class */ (function () {
    function IconChevronRight() {
    }
    IconChevronRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronRightComponent],
                    exports: [IconChevronRightComponent]
                },] }
    ];
    return IconChevronRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronUpComponent = /** @class */ (function () {
    function IconChevronUpComponent() {
    }
    IconChevronUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevron-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevron-up\">\n    <polyline points=\"18 15 12 9 6 15\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronUpComponent;
}());
var IconChevronUp = /** @class */ (function () {
    function IconChevronUp() {
    }
    IconChevronUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronUpComponent],
                    exports: [IconChevronUpComponent]
                },] }
    ];
    return IconChevronUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronsDownComponent = /** @class */ (function () {
    function IconChevronsDownComponent() {
    }
    IconChevronsDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevrons-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevrons-down\">\n    <polyline points=\"7 13 12 18 17 13\"></polyline><polyline points=\"7 6 12 11 17 6\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronsDownComponent;
}());
var IconChevronsDown = /** @class */ (function () {
    function IconChevronsDown() {
    }
    IconChevronsDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronsDownComponent],
                    exports: [IconChevronsDownComponent]
                },] }
    ];
    return IconChevronsDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronsLeftComponent = /** @class */ (function () {
    function IconChevronsLeftComponent() {
    }
    IconChevronsLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevrons-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevrons-left\">\n    <polyline points=\"11 17 6 12 11 7\"></polyline><polyline points=\"18 17 13 12 18 7\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronsLeftComponent;
}());
var IconChevronsLeft = /** @class */ (function () {
    function IconChevronsLeft() {
    }
    IconChevronsLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronsLeftComponent],
                    exports: [IconChevronsLeftComponent]
                },] }
    ];
    return IconChevronsLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronsRightComponent = /** @class */ (function () {
    function IconChevronsRightComponent() {
    }
    IconChevronsRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevrons-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevrons-right\">\n    <polyline points=\"13 17 18 12 13 7\"></polyline><polyline points=\"6 17 11 12 6 7\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronsRightComponent;
}());
var IconChevronsRight = /** @class */ (function () {
    function IconChevronsRight() {
    }
    IconChevronsRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronsRightComponent],
                    exports: [IconChevronsRightComponent]
                },] }
    ];
    return IconChevronsRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChevronsUpComponent = /** @class */ (function () {
    function IconChevronsUpComponent() {
    }
    IconChevronsUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chevrons-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chevrons-up\">\n    <polyline points=\"17 11 12 6 7 11\"></polyline><polyline points=\"17 18 12 13 7 18\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChevronsUpComponent;
}());
var IconChevronsUp = /** @class */ (function () {
    function IconChevronsUp() {
    }
    IconChevronsUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChevronsUpComponent],
                    exports: [IconChevronsUpComponent]
                },] }
    ];
    return IconChevronsUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconChromeComponent = /** @class */ (function () {
    function IconChromeComponent() {
    }
    IconChromeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-chrome',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-chrome\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"4\"></circle><line x1=\"21.17\" y1=\"8\" x2=\"12\" y2=\"8\"></line><line x1=\"3.95\" y1=\"6.06\" x2=\"8.54\" y2=\"14\"></line><line x1=\"10.88\" y1=\"21.94\" x2=\"15.46\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconChromeComponent;
}());
var IconChrome = /** @class */ (function () {
    function IconChrome() {
    }
    IconChrome.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconChromeComponent],
                    exports: [IconChromeComponent]
                },] }
    ];
    return IconChrome;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCircleComponent = /** @class */ (function () {
    function IconCircleComponent() {
    }
    IconCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCircleComponent;
}());
var IconCircle = /** @class */ (function () {
    function IconCircle() {
    }
    IconCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCircleComponent],
                    exports: [IconCircleComponent]
                },] }
    ];
    return IconCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconClipboardComponent = /** @class */ (function () {
    function IconClipboardComponent() {
    }
    IconClipboardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-clipboard',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-clipboard\">\n    <path d=\"M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2\"></path><rect x=\"8\" y=\"2\" width=\"8\" height=\"4\" rx=\"1\" ry=\"1\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconClipboardComponent;
}());
var IconClipboard = /** @class */ (function () {
    function IconClipboard() {
    }
    IconClipboard.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconClipboardComponent],
                    exports: [IconClipboardComponent]
                },] }
    ];
    return IconClipboard;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconClockComponent = /** @class */ (function () {
    function IconClockComponent() {
    }
    IconClockComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-clock',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-clock\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 6 12 12 16 14\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconClockComponent;
}());
var IconClock = /** @class */ (function () {
    function IconClock() {
    }
    IconClock.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconClockComponent],
                    exports: [IconClockComponent]
                },] }
    ];
    return IconClock;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCloudDrizzleComponent = /** @class */ (function () {
    function IconCloudDrizzleComponent() {
    }
    IconCloudDrizzleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cloud-drizzle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cloud-drizzle\">\n    <line x1=\"8\" y1=\"19\" x2=\"8\" y2=\"21\"></line><line x1=\"8\" y1=\"13\" x2=\"8\" y2=\"15\"></line><line x1=\"16\" y1=\"19\" x2=\"16\" y2=\"21\"></line><line x1=\"16\" y1=\"13\" x2=\"16\" y2=\"15\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\"></line><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"17\"></line><path d=\"M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCloudDrizzleComponent;
}());
var IconCloudDrizzle = /** @class */ (function () {
    function IconCloudDrizzle() {
    }
    IconCloudDrizzle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCloudDrizzleComponent],
                    exports: [IconCloudDrizzleComponent]
                },] }
    ];
    return IconCloudDrizzle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCloudLightningComponent = /** @class */ (function () {
    function IconCloudLightningComponent() {
    }
    IconCloudLightningComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cloud-lightning',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cloud-lightning\">\n    <path d=\"M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9\"></path><polyline points=\"13 11 9 17 15 17 11 23\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCloudLightningComponent;
}());
var IconCloudLightning = /** @class */ (function () {
    function IconCloudLightning() {
    }
    IconCloudLightning.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCloudLightningComponent],
                    exports: [IconCloudLightningComponent]
                },] }
    ];
    return IconCloudLightning;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCloudOffComponent = /** @class */ (function () {
    function IconCloudOffComponent() {
    }
    IconCloudOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cloud-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cloud-off\">\n    <path d=\"M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCloudOffComponent;
}());
var IconCloudOff = /** @class */ (function () {
    function IconCloudOff() {
    }
    IconCloudOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCloudOffComponent],
                    exports: [IconCloudOffComponent]
                },] }
    ];
    return IconCloudOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCloudRainComponent = /** @class */ (function () {
    function IconCloudRainComponent() {
    }
    IconCloudRainComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cloud-rain',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cloud-rain\">\n    <line x1=\"16\" y1=\"13\" x2=\"16\" y2=\"21\"></line><line x1=\"8\" y1=\"13\" x2=\"8\" y2=\"21\"></line><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"23\"></line><path d=\"M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCloudRainComponent;
}());
var IconCloudRain = /** @class */ (function () {
    function IconCloudRain() {
    }
    IconCloudRain.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCloudRainComponent],
                    exports: [IconCloudRainComponent]
                },] }
    ];
    return IconCloudRain;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCloudSnowComponent = /** @class */ (function () {
    function IconCloudSnowComponent() {
    }
    IconCloudSnowComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cloud-snow',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cloud-snow\">\n    <path d=\"M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25\"></path><line x1=\"8\" y1=\"16\" x2=\"8\" y2=\"16\"></line><line x1=\"8\" y1=\"20\" x2=\"8\" y2=\"20\"></line><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"18\"></line><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"22\"></line><line x1=\"16\" y1=\"16\" x2=\"16\" y2=\"16\"></line><line x1=\"16\" y1=\"20\" x2=\"16\" y2=\"20\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCloudSnowComponent;
}());
var IconCloudSnow = /** @class */ (function () {
    function IconCloudSnow() {
    }
    IconCloudSnow.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCloudSnowComponent],
                    exports: [IconCloudSnowComponent]
                },] }
    ];
    return IconCloudSnow;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCloudComponent = /** @class */ (function () {
    function IconCloudComponent() {
    }
    IconCloudComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cloud',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cloud\">\n    <path d=\"M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCloudComponent;
}());
var IconCloud = /** @class */ (function () {
    function IconCloud() {
    }
    IconCloud.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCloudComponent],
                    exports: [IconCloudComponent]
                },] }
    ];
    return IconCloud;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCodeComponent = /** @class */ (function () {
    function IconCodeComponent() {
    }
    IconCodeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-code',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-code\">\n    <polyline points=\"16 18 22 12 16 6\"></polyline><polyline points=\"8 6 2 12 8 18\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCodeComponent;
}());
var IconCode = /** @class */ (function () {
    function IconCode() {
    }
    IconCode.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCodeComponent],
                    exports: [IconCodeComponent]
                },] }
    ];
    return IconCode;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCodepenComponent = /** @class */ (function () {
    function IconCodepenComponent() {
    }
    IconCodepenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-codepen',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-codepen\">\n    <polygon points=\"12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2\"></polygon><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"15.5\"></line><polyline points=\"22 8.5 12 15.5 2 8.5\"></polyline><polyline points=\"2 15.5 12 8.5 22 15.5\"></polyline><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"8.5\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCodepenComponent;
}());
var IconCodepen = /** @class */ (function () {
    function IconCodepen() {
    }
    IconCodepen.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCodepenComponent],
                    exports: [IconCodepenComponent]
                },] }
    ];
    return IconCodepen;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCoffeeComponent = /** @class */ (function () {
    function IconCoffeeComponent() {
    }
    IconCoffeeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-coffee',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-coffee\">\n    <path d=\"M18 8h1a4 4 0 0 1 0 8h-1\"></path><path d=\"M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z\"></path><line x1=\"6\" y1=\"1\" x2=\"6\" y2=\"4\"></line><line x1=\"10\" y1=\"1\" x2=\"10\" y2=\"4\"></line><line x1=\"14\" y1=\"1\" x2=\"14\" y2=\"4\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCoffeeComponent;
}());
var IconCoffee = /** @class */ (function () {
    function IconCoffee() {
    }
    IconCoffee.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCoffeeComponent],
                    exports: [IconCoffeeComponent]
                },] }
    ];
    return IconCoffee;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCommandComponent = /** @class */ (function () {
    function IconCommandComponent() {
    }
    IconCommandComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-command',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-command\">\n    <path d=\"M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCommandComponent;
}());
var IconCommand = /** @class */ (function () {
    function IconCommand() {
    }
    IconCommand.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCommandComponent],
                    exports: [IconCommandComponent]
                },] }
    ];
    return IconCommand;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCompassComponent = /** @class */ (function () {
    function IconCompassComponent() {
    }
    IconCompassComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-compass',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-compass\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polygon points=\"16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCompassComponent;
}());
var IconCompass = /** @class */ (function () {
    function IconCompass() {
    }
    IconCompass.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCompassComponent],
                    exports: [IconCompassComponent]
                },] }
    ];
    return IconCompass;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCopyComponent = /** @class */ (function () {
    function IconCopyComponent() {
    }
    IconCopyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-copy',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-copy\">\n    <rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCopyComponent;
}());
var IconCopy = /** @class */ (function () {
    function IconCopy() {
    }
    IconCopy.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCopyComponent],
                    exports: [IconCopyComponent]
                },] }
    ];
    return IconCopy;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerDownLeftComponent = /** @class */ (function () {
    function IconCornerDownLeftComponent() {
    }
    IconCornerDownLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-down-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-down-left\">\n    <polyline points=\"9 10 4 15 9 20\"></polyline><path d=\"M20 4v7a4 4 0 0 1-4 4H4\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerDownLeftComponent;
}());
var IconCornerDownLeft = /** @class */ (function () {
    function IconCornerDownLeft() {
    }
    IconCornerDownLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerDownLeftComponent],
                    exports: [IconCornerDownLeftComponent]
                },] }
    ];
    return IconCornerDownLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerDownRightComponent = /** @class */ (function () {
    function IconCornerDownRightComponent() {
    }
    IconCornerDownRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-down-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-down-right\">\n    <polyline points=\"15 10 20 15 15 20\"></polyline><path d=\"M4 4v7a4 4 0 0 0 4 4h12\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerDownRightComponent;
}());
var IconCornerDownRight = /** @class */ (function () {
    function IconCornerDownRight() {
    }
    IconCornerDownRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerDownRightComponent],
                    exports: [IconCornerDownRightComponent]
                },] }
    ];
    return IconCornerDownRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerLeftDownComponent = /** @class */ (function () {
    function IconCornerLeftDownComponent() {
    }
    IconCornerLeftDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-left-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-left-down\">\n    <polyline points=\"14 15 9 20 4 15\"></polyline><path d=\"M20 4h-7a4 4 0 0 0-4 4v12\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerLeftDownComponent;
}());
var IconCornerLeftDown = /** @class */ (function () {
    function IconCornerLeftDown() {
    }
    IconCornerLeftDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerLeftDownComponent],
                    exports: [IconCornerLeftDownComponent]
                },] }
    ];
    return IconCornerLeftDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerLeftUpComponent = /** @class */ (function () {
    function IconCornerLeftUpComponent() {
    }
    IconCornerLeftUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-left-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-left-up\">\n    <polyline points=\"14 9 9 4 4 9\"></polyline><path d=\"M20 20h-7a4 4 0 0 1-4-4V4\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerLeftUpComponent;
}());
var IconCornerLeftUp = /** @class */ (function () {
    function IconCornerLeftUp() {
    }
    IconCornerLeftUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerLeftUpComponent],
                    exports: [IconCornerLeftUpComponent]
                },] }
    ];
    return IconCornerLeftUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerRightDownComponent = /** @class */ (function () {
    function IconCornerRightDownComponent() {
    }
    IconCornerRightDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-right-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-right-down\">\n    <polyline points=\"10 15 15 20 20 15\"></polyline><path d=\"M4 4h7a4 4 0 0 1 4 4v12\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerRightDownComponent;
}());
var IconCornerRightDown = /** @class */ (function () {
    function IconCornerRightDown() {
    }
    IconCornerRightDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerRightDownComponent],
                    exports: [IconCornerRightDownComponent]
                },] }
    ];
    return IconCornerRightDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerRightUpComponent = /** @class */ (function () {
    function IconCornerRightUpComponent() {
    }
    IconCornerRightUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-right-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-right-up\">\n    <polyline points=\"10 9 15 4 20 9\"></polyline><path d=\"M4 20h7a4 4 0 0 0 4-4V4\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerRightUpComponent;
}());
var IconCornerRightUp = /** @class */ (function () {
    function IconCornerRightUp() {
    }
    IconCornerRightUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerRightUpComponent],
                    exports: [IconCornerRightUpComponent]
                },] }
    ];
    return IconCornerRightUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerUpLeftComponent = /** @class */ (function () {
    function IconCornerUpLeftComponent() {
    }
    IconCornerUpLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-up-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-up-left\">\n    <polyline points=\"9 14 4 9 9 4\"></polyline><path d=\"M20 20v-7a4 4 0 0 0-4-4H4\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerUpLeftComponent;
}());
var IconCornerUpLeft = /** @class */ (function () {
    function IconCornerUpLeft() {
    }
    IconCornerUpLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerUpLeftComponent],
                    exports: [IconCornerUpLeftComponent]
                },] }
    ];
    return IconCornerUpLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCornerUpRightComponent = /** @class */ (function () {
    function IconCornerUpRightComponent() {
    }
    IconCornerUpRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-corner-up-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-corner-up-right\">\n    <polyline points=\"15 14 20 9 15 4\"></polyline><path d=\"M4 20v-7a4 4 0 0 1 4-4h12\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCornerUpRightComponent;
}());
var IconCornerUpRight = /** @class */ (function () {
    function IconCornerUpRight() {
    }
    IconCornerUpRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCornerUpRightComponent],
                    exports: [IconCornerUpRightComponent]
                },] }
    ];
    return IconCornerUpRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCpuComponent = /** @class */ (function () {
    function IconCpuComponent() {
    }
    IconCpuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-cpu',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-cpu\">\n    <rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\" ry=\"2\"></rect><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect><line x1=\"9\" y1=\"1\" x2=\"9\" y2=\"4\"></line><line x1=\"15\" y1=\"1\" x2=\"15\" y2=\"4\"></line><line x1=\"9\" y1=\"20\" x2=\"9\" y2=\"23\"></line><line x1=\"15\" y1=\"20\" x2=\"15\" y2=\"23\"></line><line x1=\"20\" y1=\"9\" x2=\"23\" y2=\"9\"></line><line x1=\"20\" y1=\"14\" x2=\"23\" y2=\"14\"></line><line x1=\"1\" y1=\"9\" x2=\"4\" y2=\"9\"></line><line x1=\"1\" y1=\"14\" x2=\"4\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCpuComponent;
}());
var IconCpu = /** @class */ (function () {
    function IconCpu() {
    }
    IconCpu.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCpuComponent],
                    exports: [IconCpuComponent]
                },] }
    ];
    return IconCpu;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCreditCardComponent = /** @class */ (function () {
    function IconCreditCardComponent() {
    }
    IconCreditCardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-credit-card',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-credit-card\">\n    <rect x=\"1\" y=\"4\" width=\"22\" height=\"16\" rx=\"2\" ry=\"2\"></rect><line x1=\"1\" y1=\"10\" x2=\"23\" y2=\"10\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCreditCardComponent;
}());
var IconCreditCard = /** @class */ (function () {
    function IconCreditCard() {
    }
    IconCreditCard.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCreditCardComponent],
                    exports: [IconCreditCardComponent]
                },] }
    ];
    return IconCreditCard;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCropComponent = /** @class */ (function () {
    function IconCropComponent() {
    }
    IconCropComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-crop',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-crop\">\n    <path d=\"M6.13 1L6 16a2 2 0 0 0 2 2h15\"></path><path d=\"M1 6.13L16 6a2 2 0 0 1 2 2v15\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCropComponent;
}());
var IconCrop = /** @class */ (function () {
    function IconCrop() {
    }
    IconCrop.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCropComponent],
                    exports: [IconCropComponent]
                },] }
    ];
    return IconCrop;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconCrosshairComponent = /** @class */ (function () {
    function IconCrosshairComponent() {
    }
    IconCrosshairComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-crosshair',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-crosshair\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"22\" y1=\"12\" x2=\"18\" y2=\"12\"></line><line x1=\"6\" y1=\"12\" x2=\"2\" y2=\"12\"></line><line x1=\"12\" y1=\"6\" x2=\"12\" y2=\"2\"></line><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconCrosshairComponent;
}());
var IconCrosshair = /** @class */ (function () {
    function IconCrosshair() {
    }
    IconCrosshair.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconCrosshairComponent],
                    exports: [IconCrosshairComponent]
                },] }
    ];
    return IconCrosshair;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDatabaseComponent = /** @class */ (function () {
    function IconDatabaseComponent() {
    }
    IconDatabaseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-database',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-database\">\n    <ellipse cx=\"12\" cy=\"5\" rx=\"9\" ry=\"3\"></ellipse><path d=\"M21 12c0 1.66-4 3-9 3s-9-1.34-9-3\"></path><path d=\"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDatabaseComponent;
}());
var IconDatabase = /** @class */ (function () {
    function IconDatabase() {
    }
    IconDatabase.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDatabaseComponent],
                    exports: [IconDatabaseComponent]
                },] }
    ];
    return IconDatabase;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDeleteComponent = /** @class */ (function () {
    function IconDeleteComponent() {
    }
    IconDeleteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-delete',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-delete\">\n    <path d=\"M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z\"></path><line x1=\"18\" y1=\"9\" x2=\"12\" y2=\"15\"></line><line x1=\"12\" y1=\"9\" x2=\"18\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDeleteComponent;
}());
var IconDelete = /** @class */ (function () {
    function IconDelete() {
    }
    IconDelete.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDeleteComponent],
                    exports: [IconDeleteComponent]
                },] }
    ];
    return IconDelete;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDiscComponent = /** @class */ (function () {
    function IconDiscComponent() {
    }
    IconDiscComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-disc',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-disc\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"3\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDiscComponent;
}());
var IconDisc = /** @class */ (function () {
    function IconDisc() {
    }
    IconDisc.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDiscComponent],
                    exports: [IconDiscComponent]
                },] }
    ];
    return IconDisc;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDollarSignComponent = /** @class */ (function () {
    function IconDollarSignComponent() {
    }
    IconDollarSignComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-dollar-sign',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-dollar-sign\">\n    <line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"23\"></line><path d=\"M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDollarSignComponent;
}());
var IconDollarSign = /** @class */ (function () {
    function IconDollarSign() {
    }
    IconDollarSign.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDollarSignComponent],
                    exports: [IconDollarSignComponent]
                },] }
    ];
    return IconDollarSign;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDownloadCloudComponent = /** @class */ (function () {
    function IconDownloadCloudComponent() {
    }
    IconDownloadCloudComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-download-cloud',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-download-cloud\">\n    <polyline points=\"8 17 12 21 16 17\"></polyline><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"21\"></line><path d=\"M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDownloadCloudComponent;
}());
var IconDownloadCloud = /** @class */ (function () {
    function IconDownloadCloud() {
    }
    IconDownloadCloud.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDownloadCloudComponent],
                    exports: [IconDownloadCloudComponent]
                },] }
    ];
    return IconDownloadCloud;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDownloadComponent = /** @class */ (function () {
    function IconDownloadComponent() {
    }
    IconDownloadComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-download',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-download\">\n    <path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"></path><polyline points=\"7 10 12 15 17 10\"></polyline><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"3\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDownloadComponent;
}());
var IconDownload = /** @class */ (function () {
    function IconDownload() {
    }
    IconDownload.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDownloadComponent],
                    exports: [IconDownloadComponent]
                },] }
    ];
    return IconDownload;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconDropletComponent = /** @class */ (function () {
    function IconDropletComponent() {
    }
    IconDropletComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-droplet',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-droplet\">\n    <path d=\"M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconDropletComponent;
}());
var IconDroplet = /** @class */ (function () {
    function IconDroplet() {
    }
    IconDroplet.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconDropletComponent],
                    exports: [IconDropletComponent]
                },] }
    ];
    return IconDroplet;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconEdit2Component = /** @class */ (function () {
    function IconEdit2Component() {
    }
    IconEdit2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-edit-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-edit-2\">\n    <path d=\"M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconEdit2Component;
}());
var IconEdit2 = /** @class */ (function () {
    function IconEdit2() {
    }
    IconEdit2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconEdit2Component],
                    exports: [IconEdit2Component]
                },] }
    ];
    return IconEdit2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconEdit3Component = /** @class */ (function () {
    function IconEdit3Component() {
    }
    IconEdit3Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-edit-3',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-edit-3\">\n    <path d=\"M12 20h9\"></path><path d=\"M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconEdit3Component;
}());
var IconEdit3 = /** @class */ (function () {
    function IconEdit3() {
    }
    IconEdit3.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconEdit3Component],
                    exports: [IconEdit3Component]
                },] }
    ];
    return IconEdit3;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconEditComponent = /** @class */ (function () {
    function IconEditComponent() {
    }
    IconEditComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-edit',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-edit\">\n    <path d=\"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7\"></path><path d=\"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconEditComponent;
}());
var IconEdit = /** @class */ (function () {
    function IconEdit() {
    }
    IconEdit.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconEditComponent],
                    exports: [IconEditComponent]
                },] }
    ];
    return IconEdit;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconExternalLinkComponent = /** @class */ (function () {
    function IconExternalLinkComponent() {
    }
    IconExternalLinkComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-external-link',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-external-link\">\n    <path d=\"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6\"></path><polyline points=\"15 3 21 3 21 9\"></polyline><line x1=\"10\" y1=\"14\" x2=\"21\" y2=\"3\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconExternalLinkComponent;
}());
var IconExternalLink = /** @class */ (function () {
    function IconExternalLink() {
    }
    IconExternalLink.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconExternalLinkComponent],
                    exports: [IconExternalLinkComponent]
                },] }
    ];
    return IconExternalLink;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconEyeOffComponent = /** @class */ (function () {
    function IconEyeOffComponent() {
    }
    IconEyeOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-eye-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-eye-off\">\n    <path d=\"M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconEyeOffComponent;
}());
var IconEyeOff = /** @class */ (function () {
    function IconEyeOff() {
    }
    IconEyeOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconEyeOffComponent],
                    exports: [IconEyeOffComponent]
                },] }
    ];
    return IconEyeOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconEyeComponent = /** @class */ (function () {
    function IconEyeComponent() {
    }
    IconEyeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-eye',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-eye\">\n    <path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\"></path><circle cx=\"12\" cy=\"12\" r=\"3\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconEyeComponent;
}());
var IconEye = /** @class */ (function () {
    function IconEye() {
    }
    IconEye.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconEyeComponent],
                    exports: [IconEyeComponent]
                },] }
    ];
    return IconEye;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFacebookComponent = /** @class */ (function () {
    function IconFacebookComponent() {
    }
    IconFacebookComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-facebook',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-facebook\">\n    <path d=\"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFacebookComponent;
}());
var IconFacebook = /** @class */ (function () {
    function IconFacebook() {
    }
    IconFacebook.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFacebookComponent],
                    exports: [IconFacebookComponent]
                },] }
    ];
    return IconFacebook;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFastForwardComponent = /** @class */ (function () {
    function IconFastForwardComponent() {
    }
    IconFastForwardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-fast-forward',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-fast-forward\">\n    <polygon points=\"13 19 22 12 13 5 13 19\"></polygon><polygon points=\"2 19 11 12 2 5 2 19\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFastForwardComponent;
}());
var IconFastForward = /** @class */ (function () {
    function IconFastForward() {
    }
    IconFastForward.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFastForwardComponent],
                    exports: [IconFastForwardComponent]
                },] }
    ];
    return IconFastForward;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFeatherComponent = /** @class */ (function () {
    function IconFeatherComponent() {
    }
    IconFeatherComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-feather',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-feather\">\n    <path d=\"M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z\"></path><line x1=\"16\" y1=\"8\" x2=\"2\" y2=\"22\"></line><line x1=\"17.5\" y1=\"15\" x2=\"9\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFeatherComponent;
}());
var IconFeather = /** @class */ (function () {
    function IconFeather() {
    }
    IconFeather.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFeatherComponent],
                    exports: [IconFeatherComponent]
                },] }
    ];
    return IconFeather;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFigmaComponent = /** @class */ (function () {
    function IconFigmaComponent() {
    }
    IconFigmaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-figma',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-figma\">\n    <path d=\"M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z\"></path><path d=\"M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z\"></path><path d=\"M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z\"></path><path d=\"M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z\"></path><path d=\"M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFigmaComponent;
}());
var IconFigma = /** @class */ (function () {
    function IconFigma() {
    }
    IconFigma.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFigmaComponent],
                    exports: [IconFigmaComponent]
                },] }
    ];
    return IconFigma;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFileMinusComponent = /** @class */ (function () {
    function IconFileMinusComponent() {
    }
    IconFileMinusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-file-minus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-file-minus\">\n    <path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFileMinusComponent;
}());
var IconFileMinus = /** @class */ (function () {
    function IconFileMinus() {
    }
    IconFileMinus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFileMinusComponent],
                    exports: [IconFileMinusComponent]
                },] }
    ];
    return IconFileMinus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFilePlusComponent = /** @class */ (function () {
    function IconFilePlusComponent() {
    }
    IconFilePlusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-file-plus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-file-plus\">\n    <path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"12\"></line><line x1=\"9\" y1=\"15\" x2=\"15\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFilePlusComponent;
}());
var IconFilePlus = /** @class */ (function () {
    function IconFilePlus() {
    }
    IconFilePlus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFilePlusComponent],
                    exports: [IconFilePlusComponent]
                },] }
    ];
    return IconFilePlus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFileTextComponent = /** @class */ (function () {
    function IconFileTextComponent() {
    }
    IconFileTextComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-file-text',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-file-text\">\n    <path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line><polyline points=\"10 9 9 9 8 9\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFileTextComponent;
}());
var IconFileText = /** @class */ (function () {
    function IconFileText() {
    }
    IconFileText.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFileTextComponent],
                    exports: [IconFileTextComponent]
                },] }
    ];
    return IconFileText;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFileComponent = /** @class */ (function () {
    function IconFileComponent() {
    }
    IconFileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-file',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-file\">\n    <path d=\"M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z\"></path><polyline points=\"13 2 13 9 20 9\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFileComponent;
}());
var IconFile = /** @class */ (function () {
    function IconFile() {
    }
    IconFile.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFileComponent],
                    exports: [IconFileComponent]
                },] }
    ];
    return IconFile;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFilmComponent = /** @class */ (function () {
    function IconFilmComponent() {
    }
    IconFilmComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-film',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-film\">\n    <rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"2.18\" ry=\"2.18\"></rect><line x1=\"7\" y1=\"2\" x2=\"7\" y2=\"22\"></line><line x1=\"17\" y1=\"2\" x2=\"17\" y2=\"22\"></line><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"2\" y1=\"7\" x2=\"7\" y2=\"7\"></line><line x1=\"2\" y1=\"17\" x2=\"7\" y2=\"17\"></line><line x1=\"17\" y1=\"17\" x2=\"22\" y2=\"17\"></line><line x1=\"17\" y1=\"7\" x2=\"22\" y2=\"7\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFilmComponent;
}());
var IconFilm = /** @class */ (function () {
    function IconFilm() {
    }
    IconFilm.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFilmComponent],
                    exports: [IconFilmComponent]
                },] }
    ];
    return IconFilm;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFilterComponent = /** @class */ (function () {
    function IconFilterComponent() {
    }
    IconFilterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-filter',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-filter\">\n    <polygon points=\"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFilterComponent;
}());
var IconFilter = /** @class */ (function () {
    function IconFilter() {
    }
    IconFilter.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFilterComponent],
                    exports: [IconFilterComponent]
                },] }
    ];
    return IconFilter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFlagComponent = /** @class */ (function () {
    function IconFlagComponent() {
    }
    IconFlagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-flag',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-flag\">\n    <path d=\"M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z\"></path><line x1=\"4\" y1=\"22\" x2=\"4\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFlagComponent;
}());
var IconFlag = /** @class */ (function () {
    function IconFlag() {
    }
    IconFlag.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFlagComponent],
                    exports: [IconFlagComponent]
                },] }
    ];
    return IconFlag;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFolderMinusComponent = /** @class */ (function () {
    function IconFolderMinusComponent() {
    }
    IconFolderMinusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-folder-minus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-folder-minus\">\n    <path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFolderMinusComponent;
}());
var IconFolderMinus = /** @class */ (function () {
    function IconFolderMinus() {
    }
    IconFolderMinus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFolderMinusComponent],
                    exports: [IconFolderMinusComponent]
                },] }
    ];
    return IconFolderMinus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFolderPlusComponent = /** @class */ (function () {
    function IconFolderPlusComponent() {
    }
    IconFolderPlusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-folder-plus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-folder-plus\">\n    <path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path><line x1=\"12\" y1=\"11\" x2=\"12\" y2=\"17\"></line><line x1=\"9\" y1=\"14\" x2=\"15\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFolderPlusComponent;
}());
var IconFolderPlus = /** @class */ (function () {
    function IconFolderPlus() {
    }
    IconFolderPlus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFolderPlusComponent],
                    exports: [IconFolderPlusComponent]
                },] }
    ];
    return IconFolderPlus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFolderComponent = /** @class */ (function () {
    function IconFolderComponent() {
    }
    IconFolderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-folder',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-folder\">\n    <path d=\"M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFolderComponent;
}());
var IconFolder = /** @class */ (function () {
    function IconFolder() {
    }
    IconFolder.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFolderComponent],
                    exports: [IconFolderComponent]
                },] }
    ];
    return IconFolder;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconFrownComponent = /** @class */ (function () {
    function IconFrownComponent() {
    }
    IconFrownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-frown',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-frown\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M16 16s-1.5-2-4-2-4 2-4 2\"></path><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\"></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconFrownComponent;
}());
var IconFrown = /** @class */ (function () {
    function IconFrown() {
    }
    IconFrown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconFrownComponent],
                    exports: [IconFrownComponent]
                },] }
    ];
    return IconFrown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGiftComponent = /** @class */ (function () {
    function IconGiftComponent() {
    }
    IconGiftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-gift',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-gift\">\n    <polyline points=\"20 12 20 22 4 22 4 12\"></polyline><rect x=\"2\" y=\"7\" width=\"20\" height=\"5\"></rect><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"7\"></line><path d=\"M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z\"></path><path d=\"M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGiftComponent;
}());
var IconGift = /** @class */ (function () {
    function IconGift() {
    }
    IconGift.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGiftComponent],
                    exports: [IconGiftComponent]
                },] }
    ];
    return IconGift;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGitBranchComponent = /** @class */ (function () {
    function IconGitBranchComponent() {
    }
    IconGitBranchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-git-branch',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-git-branch\">\n    <line x1=\"6\" y1=\"3\" x2=\"6\" y2=\"15\"></line><circle cx=\"18\" cy=\"6\" r=\"3\"></circle><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><path d=\"M18 9a9 9 0 0 1-9 9\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGitBranchComponent;
}());
var IconGitBranch = /** @class */ (function () {
    function IconGitBranch() {
    }
    IconGitBranch.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGitBranchComponent],
                    exports: [IconGitBranchComponent]
                },] }
    ];
    return IconGitBranch;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGitCommitComponent = /** @class */ (function () {
    function IconGitCommitComponent() {
    }
    IconGitCommitComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-git-commit',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-git-commit\">\n    <circle cx=\"12\" cy=\"12\" r=\"4\"></circle><line x1=\"1.05\" y1=\"12\" x2=\"7\" y2=\"12\"></line><line x1=\"17.01\" y1=\"12\" x2=\"22.96\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGitCommitComponent;
}());
var IconGitCommit = /** @class */ (function () {
    function IconGitCommit() {
    }
    IconGitCommit.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGitCommitComponent],
                    exports: [IconGitCommitComponent]
                },] }
    ];
    return IconGitCommit;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGitMergeComponent = /** @class */ (function () {
    function IconGitMergeComponent() {
    }
    IconGitMergeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-git-merge',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-git-merge\">\n    <circle cx=\"18\" cy=\"18\" r=\"3\"></circle><circle cx=\"6\" cy=\"6\" r=\"3\"></circle><path d=\"M6 21V9a9 9 0 0 0 9 9\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGitMergeComponent;
}());
var IconGitMerge = /** @class */ (function () {
    function IconGitMerge() {
    }
    IconGitMerge.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGitMergeComponent],
                    exports: [IconGitMergeComponent]
                },] }
    ];
    return IconGitMerge;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGitPullRequestComponent = /** @class */ (function () {
    function IconGitPullRequestComponent() {
    }
    IconGitPullRequestComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-git-pull-request',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-git-pull-request\">\n    <circle cx=\"18\" cy=\"18\" r=\"3\"></circle><circle cx=\"6\" cy=\"6\" r=\"3\"></circle><path d=\"M13 6h3a2 2 0 0 1 2 2v7\"></path><line x1=\"6\" y1=\"9\" x2=\"6\" y2=\"21\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGitPullRequestComponent;
}());
var IconGitPullRequest = /** @class */ (function () {
    function IconGitPullRequest() {
    }
    IconGitPullRequest.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGitPullRequestComponent],
                    exports: [IconGitPullRequestComponent]
                },] }
    ];
    return IconGitPullRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGithubComponent = /** @class */ (function () {
    function IconGithubComponent() {
    }
    IconGithubComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-github',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-github\">\n    <path d=\"M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGithubComponent;
}());
var IconGithub = /** @class */ (function () {
    function IconGithub() {
    }
    IconGithub.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGithubComponent],
                    exports: [IconGithubComponent]
                },] }
    ];
    return IconGithub;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGitlabComponent = /** @class */ (function () {
    function IconGitlabComponent() {
    }
    IconGitlabComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-gitlab',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-gitlab\">\n    <path d=\"M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGitlabComponent;
}());
var IconGitlab = /** @class */ (function () {
    function IconGitlab() {
    }
    IconGitlab.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGitlabComponent],
                    exports: [IconGitlabComponent]
                },] }
    ];
    return IconGitlab;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGlobeComponent = /** @class */ (function () {
    function IconGlobeComponent() {
    }
    IconGlobeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-globe',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-globe\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><path d=\"M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGlobeComponent;
}());
var IconGlobe = /** @class */ (function () {
    function IconGlobe() {
    }
    IconGlobe.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGlobeComponent],
                    exports: [IconGlobeComponent]
                },] }
    ];
    return IconGlobe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconGridComponent = /** @class */ (function () {
    function IconGridComponent() {
    }
    IconGridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-grid',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-grid\">\n    <rect x=\"3\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconGridComponent;
}());
var IconGrid = /** @class */ (function () {
    function IconGrid() {
    }
    IconGrid.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconGridComponent],
                    exports: [IconGridComponent]
                },] }
    ];
    return IconGrid;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconHardDriveComponent = /** @class */ (function () {
    function IconHardDriveComponent() {
    }
    IconHardDriveComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-hard-drive',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-hard-drive\">\n    <line x1=\"22\" y1=\"12\" x2=\"2\" y2=\"12\"></line><path d=\"M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\"></path><line x1=\"6\" y1=\"16\" x2=\"6\" y2=\"16\"></line><line x1=\"10\" y1=\"16\" x2=\"10\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconHardDriveComponent;
}());
var IconHardDrive = /** @class */ (function () {
    function IconHardDrive() {
    }
    IconHardDrive.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconHardDriveComponent],
                    exports: [IconHardDriveComponent]
                },] }
    ];
    return IconHardDrive;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconHashComponent = /** @class */ (function () {
    function IconHashComponent() {
    }
    IconHashComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-hash',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-hash\">\n    <line x1=\"4\" y1=\"9\" x2=\"20\" y2=\"9\"></line><line x1=\"4\" y1=\"15\" x2=\"20\" y2=\"15\"></line><line x1=\"10\" y1=\"3\" x2=\"8\" y2=\"21\"></line><line x1=\"16\" y1=\"3\" x2=\"14\" y2=\"21\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconHashComponent;
}());
var IconHash = /** @class */ (function () {
    function IconHash() {
    }
    IconHash.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconHashComponent],
                    exports: [IconHashComponent]
                },] }
    ];
    return IconHash;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconHeadphonesComponent = /** @class */ (function () {
    function IconHeadphonesComponent() {
    }
    IconHeadphonesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-headphones',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-headphones\">\n    <path d=\"M3 18v-6a9 9 0 0 1 18 0v6\"></path><path d=\"M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconHeadphonesComponent;
}());
var IconHeadphones = /** @class */ (function () {
    function IconHeadphones() {
    }
    IconHeadphones.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconHeadphonesComponent],
                    exports: [IconHeadphonesComponent]
                },] }
    ];
    return IconHeadphones;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconHeartComponent = /** @class */ (function () {
    function IconHeartComponent() {
    }
    IconHeartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-heart',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-heart\">\n    <path d=\"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconHeartComponent;
}());
var IconHeart = /** @class */ (function () {
    function IconHeart() {
    }
    IconHeart.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconHeartComponent],
                    exports: [IconHeartComponent]
                },] }
    ];
    return IconHeart;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconHelpCircleComponent = /** @class */ (function () {
    function IconHelpCircleComponent() {
    }
    IconHelpCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-help-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-help-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3\"></path><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"17\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconHelpCircleComponent;
}());
var IconHelpCircle = /** @class */ (function () {
    function IconHelpCircle() {
    }
    IconHelpCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconHelpCircleComponent],
                    exports: [IconHelpCircleComponent]
                },] }
    ];
    return IconHelpCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconHomeComponent = /** @class */ (function () {
    function IconHomeComponent() {
    }
    IconHomeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-home',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-home\">\n    <path d=\"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z\"></path><polyline points=\"9 22 9 12 15 12 15 22\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconHomeComponent;
}());
var IconHome = /** @class */ (function () {
    function IconHome() {
    }
    IconHome.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconHomeComponent],
                    exports: [IconHomeComponent]
                },] }
    ];
    return IconHome;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconImageComponent = /** @class */ (function () {
    function IconImageComponent() {
    }
    IconImageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-image',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-image\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"></circle><polyline points=\"21 15 16 10 5 21\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconImageComponent;
}());
var IconImage = /** @class */ (function () {
    function IconImage() {
    }
    IconImage.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconImageComponent],
                    exports: [IconImageComponent]
                },] }
    ];
    return IconImage;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconInboxComponent = /** @class */ (function () {
    function IconInboxComponent() {
    }
    IconInboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-inbox',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-inbox\">\n    <polyline points=\"22 12 16 12 14 15 10 15 8 12 2 12\"></polyline><path d=\"M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconInboxComponent;
}());
var IconInbox = /** @class */ (function () {
    function IconInbox() {
    }
    IconInbox.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconInboxComponent],
                    exports: [IconInboxComponent]
                },] }
    ];
    return IconInbox;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconInfoComponent = /** @class */ (function () {
    function IconInfoComponent() {
    }
    IconInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-info',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-info\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"8\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconInfoComponent;
}());
var IconInfo = /** @class */ (function () {
    function IconInfo() {
    }
    IconInfo.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconInfoComponent],
                    exports: [IconInfoComponent]
                },] }
    ];
    return IconInfo;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconInstagramComponent = /** @class */ (function () {
    function IconInstagramComponent() {
    }
    IconInstagramComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-instagram',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-instagram\">\n    <rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" ry=\"5\"></rect><path d=\"M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z\"></path><line x1=\"17.5\" y1=\"6.5\" x2=\"17.5\" y2=\"6.5\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconInstagramComponent;
}());
var IconInstagram = /** @class */ (function () {
    function IconInstagram() {
    }
    IconInstagram.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconInstagramComponent],
                    exports: [IconInstagramComponent]
                },] }
    ];
    return IconInstagram;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconItalicComponent = /** @class */ (function () {
    function IconItalicComponent() {
    }
    IconItalicComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-italic',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-italic\">\n    <line x1=\"19\" y1=\"4\" x2=\"10\" y2=\"4\"></line><line x1=\"14\" y1=\"20\" x2=\"5\" y2=\"20\"></line><line x1=\"15\" y1=\"4\" x2=\"9\" y2=\"20\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconItalicComponent;
}());
var IconItalic = /** @class */ (function () {
    function IconItalic() {
    }
    IconItalic.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconItalicComponent],
                    exports: [IconItalicComponent]
                },] }
    ];
    return IconItalic;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconKeyComponent = /** @class */ (function () {
    function IconKeyComponent() {
    }
    IconKeyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-key',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-key\">\n    <path d=\"M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconKeyComponent;
}());
var IconKey = /** @class */ (function () {
    function IconKey() {
    }
    IconKey.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconKeyComponent],
                    exports: [IconKeyComponent]
                },] }
    ];
    return IconKey;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLayersComponent = /** @class */ (function () {
    function IconLayersComponent() {
    }
    IconLayersComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-layers',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-layers\">\n    <polygon points=\"12 2 2 7 12 12 22 7 12 2\"></polygon><polyline points=\"2 17 12 22 22 17\"></polyline><polyline points=\"2 12 12 17 22 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLayersComponent;
}());
var IconLayers = /** @class */ (function () {
    function IconLayers() {
    }
    IconLayers.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLayersComponent],
                    exports: [IconLayersComponent]
                },] }
    ];
    return IconLayers;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLayoutComponent = /** @class */ (function () {
    function IconLayoutComponent() {
    }
    IconLayoutComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-layout',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-layout\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\"></line><line x1=\"9\" y1=\"21\" x2=\"9\" y2=\"9\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLayoutComponent;
}());
var IconLayout = /** @class */ (function () {
    function IconLayout() {
    }
    IconLayout.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLayoutComponent],
                    exports: [IconLayoutComponent]
                },] }
    ];
    return IconLayout;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLifeBuoyComponent = /** @class */ (function () {
    function IconLifeBuoyComponent() {
    }
    IconLifeBuoyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-life-buoy',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-life-buoy\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"4\"></circle><line x1=\"4.93\" y1=\"4.93\" x2=\"9.17\" y2=\"9.17\"></line><line x1=\"14.83\" y1=\"14.83\" x2=\"19.07\" y2=\"19.07\"></line><line x1=\"14.83\" y1=\"9.17\" x2=\"19.07\" y2=\"4.93\"></line><line x1=\"14.83\" y1=\"9.17\" x2=\"18.36\" y2=\"5.64\"></line><line x1=\"4.93\" y1=\"19.07\" x2=\"9.17\" y2=\"14.83\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLifeBuoyComponent;
}());
var IconLifeBuoy = /** @class */ (function () {
    function IconLifeBuoy() {
    }
    IconLifeBuoy.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLifeBuoyComponent],
                    exports: [IconLifeBuoyComponent]
                },] }
    ];
    return IconLifeBuoy;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLink2Component = /** @class */ (function () {
    function IconLink2Component() {
    }
    IconLink2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-link-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-link-2\">\n    <path d=\"M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3\"></path><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLink2Component;
}());
var IconLink2 = /** @class */ (function () {
    function IconLink2() {
    }
    IconLink2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLink2Component],
                    exports: [IconLink2Component]
                },] }
    ];
    return IconLink2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLinkComponent = /** @class */ (function () {
    function IconLinkComponent() {
    }
    IconLinkComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-link',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-link\">\n    <path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"></path><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLinkComponent;
}());
var IconLink = /** @class */ (function () {
    function IconLink() {
    }
    IconLink.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLinkComponent],
                    exports: [IconLinkComponent]
                },] }
    ];
    return IconLink;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLinkedinComponent = /** @class */ (function () {
    function IconLinkedinComponent() {
    }
    IconLinkedinComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-linkedin',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-linkedin\">\n    <path d=\"M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z\"></path><rect x=\"2\" y=\"9\" width=\"4\" height=\"12\"></rect><circle cx=\"4\" cy=\"4\" r=\"2\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLinkedinComponent;
}());
var IconLinkedin = /** @class */ (function () {
    function IconLinkedin() {
    }
    IconLinkedin.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLinkedinComponent],
                    exports: [IconLinkedinComponent]
                },] }
    ];
    return IconLinkedin;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconListComponent = /** @class */ (function () {
    function IconListComponent() {
    }
    IconListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-list',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-list\">\n    <line x1=\"8\" y1=\"6\" x2=\"21\" y2=\"6\"></line><line x1=\"8\" y1=\"12\" x2=\"21\" y2=\"12\"></line><line x1=\"8\" y1=\"18\" x2=\"21\" y2=\"18\"></line><line x1=\"3\" y1=\"6\" x2=\"3\" y2=\"6\"></line><line x1=\"3\" y1=\"12\" x2=\"3\" y2=\"12\"></line><line x1=\"3\" y1=\"18\" x2=\"3\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconListComponent;
}());
var IconList = /** @class */ (function () {
    function IconList() {
    }
    IconList.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconListComponent],
                    exports: [IconListComponent]
                },] }
    ];
    return IconList;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLoaderComponent = /** @class */ (function () {
    function IconLoaderComponent() {
    }
    IconLoaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-loader',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-loader\">\n    <line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"6\"></line><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"22\"></line><line x1=\"4.93\" y1=\"4.93\" x2=\"7.76\" y2=\"7.76\"></line><line x1=\"16.24\" y1=\"16.24\" x2=\"19.07\" y2=\"19.07\"></line><line x1=\"2\" y1=\"12\" x2=\"6\" y2=\"12\"></line><line x1=\"18\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"4.93\" y1=\"19.07\" x2=\"7.76\" y2=\"16.24\"></line><line x1=\"16.24\" y1=\"7.76\" x2=\"19.07\" y2=\"4.93\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLoaderComponent;
}());
var IconLoader = /** @class */ (function () {
    function IconLoader() {
    }
    IconLoader.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLoaderComponent],
                    exports: [IconLoaderComponent]
                },] }
    ];
    return IconLoader;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLockComponent = /** @class */ (function () {
    function IconLockComponent() {
    }
    IconLockComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-lock',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-lock\">\n    <rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"></rect><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLockComponent;
}());
var IconLock = /** @class */ (function () {
    function IconLock() {
    }
    IconLock.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLockComponent],
                    exports: [IconLockComponent]
                },] }
    ];
    return IconLock;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLogInComponent = /** @class */ (function () {
    function IconLogInComponent() {
    }
    IconLogInComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-log-in',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-log-in\">\n    <path d=\"M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4\"></path><polyline points=\"10 17 15 12 10 7\"></polyline><line x1=\"15\" y1=\"12\" x2=\"3\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLogInComponent;
}());
var IconLogIn = /** @class */ (function () {
    function IconLogIn() {
    }
    IconLogIn.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLogInComponent],
                    exports: [IconLogInComponent]
                },] }
    ];
    return IconLogIn;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconLogOutComponent = /** @class */ (function () {
    function IconLogOutComponent() {
    }
    IconLogOutComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-log-out',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-log-out\">\n    <path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\"></path><polyline points=\"16 17 21 12 16 7\"></polyline><line x1=\"21\" y1=\"12\" x2=\"9\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconLogOutComponent;
}());
var IconLogOut = /** @class */ (function () {
    function IconLogOut() {
    }
    IconLogOut.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconLogOutComponent],
                    exports: [IconLogOutComponent]
                },] }
    ];
    return IconLogOut;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMailComponent = /** @class */ (function () {
    function IconMailComponent() {
    }
    IconMailComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-mail',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-mail\">\n    <path d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"></path><polyline points=\"22,6 12,13 2,6\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMailComponent;
}());
var IconMail = /** @class */ (function () {
    function IconMail() {
    }
    IconMail.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMailComponent],
                    exports: [IconMailComponent]
                },] }
    ];
    return IconMail;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMapPinComponent = /** @class */ (function () {
    function IconMapPinComponent() {
    }
    IconMapPinComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-map-pin',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-map-pin\">\n    <path d=\"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z\"></path><circle cx=\"12\" cy=\"10\" r=\"3\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMapPinComponent;
}());
var IconMapPin = /** @class */ (function () {
    function IconMapPin() {
    }
    IconMapPin.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMapPinComponent],
                    exports: [IconMapPinComponent]
                },] }
    ];
    return IconMapPin;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMapComponent = /** @class */ (function () {
    function IconMapComponent() {
    }
    IconMapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-map',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-map\">\n    <polygon points=\"1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6\"></polygon><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"18\"></line><line x1=\"16\" y1=\"6\" x2=\"16\" y2=\"22\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMapComponent;
}());
var IconMap = /** @class */ (function () {
    function IconMap() {
    }
    IconMap.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMapComponent],
                    exports: [IconMapComponent]
                },] }
    ];
    return IconMap;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMaximize2Component = /** @class */ (function () {
    function IconMaximize2Component() {
    }
    IconMaximize2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-maximize-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-maximize-2\">\n    <polyline points=\"15 3 21 3 21 9\"></polyline><polyline points=\"9 21 3 21 3 15\"></polyline><line x1=\"21\" y1=\"3\" x2=\"14\" y2=\"10\"></line><line x1=\"3\" y1=\"21\" x2=\"10\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMaximize2Component;
}());
var IconMaximize2 = /** @class */ (function () {
    function IconMaximize2() {
    }
    IconMaximize2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMaximize2Component],
                    exports: [IconMaximize2Component]
                },] }
    ];
    return IconMaximize2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMaximizeComponent = /** @class */ (function () {
    function IconMaximizeComponent() {
    }
    IconMaximizeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-maximize',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-maximize\">\n    <path d=\"M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMaximizeComponent;
}());
var IconMaximize = /** @class */ (function () {
    function IconMaximize() {
    }
    IconMaximize.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMaximizeComponent],
                    exports: [IconMaximizeComponent]
                },] }
    ];
    return IconMaximize;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMehComponent = /** @class */ (function () {
    function IconMehComponent() {
    }
    IconMehComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-meh',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-meh\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"8\" y1=\"15\" x2=\"16\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\"></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMehComponent;
}());
var IconMeh = /** @class */ (function () {
    function IconMeh() {
    }
    IconMeh.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMehComponent],
                    exports: [IconMehComponent]
                },] }
    ];
    return IconMeh;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMenuComponent = /** @class */ (function () {
    function IconMenuComponent() {
    }
    IconMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-menu',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-menu\">\n    <line x1=\"3\" y1=\"12\" x2=\"21\" y2=\"12\"></line><line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\"></line><line x1=\"3\" y1=\"18\" x2=\"21\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMenuComponent;
}());
var IconMenu = /** @class */ (function () {
    function IconMenu() {
    }
    IconMenu.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMenuComponent],
                    exports: [IconMenuComponent]
                },] }
    ];
    return IconMenu;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMessageCircleComponent = /** @class */ (function () {
    function IconMessageCircleComponent() {
    }
    IconMessageCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-message-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-message-circle\">\n    <path d=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMessageCircleComponent;
}());
var IconMessageCircle = /** @class */ (function () {
    function IconMessageCircle() {
    }
    IconMessageCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMessageCircleComponent],
                    exports: [IconMessageCircleComponent]
                },] }
    ];
    return IconMessageCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMessageSquareComponent = /** @class */ (function () {
    function IconMessageSquareComponent() {
    }
    IconMessageSquareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-message-square',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-message-square\">\n    <path d=\"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMessageSquareComponent;
}());
var IconMessageSquare = /** @class */ (function () {
    function IconMessageSquare() {
    }
    IconMessageSquare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMessageSquareComponent],
                    exports: [IconMessageSquareComponent]
                },] }
    ];
    return IconMessageSquare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMicOffComponent = /** @class */ (function () {
    function IconMicOffComponent() {
    }
    IconMicOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-mic-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-mic-off\">\n    <line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line><path d=\"M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6\"></path><path d=\"M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23\"></path><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\"></line><line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMicOffComponent;
}());
var IconMicOff = /** @class */ (function () {
    function IconMicOff() {
    }
    IconMicOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMicOffComponent],
                    exports: [IconMicOffComponent]
                },] }
    ];
    return IconMicOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMicComponent = /** @class */ (function () {
    function IconMicComponent() {
    }
    IconMicComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-mic',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-mic\">\n    <path d=\"M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z\"></path><path d=\"M19 10v2a7 7 0 0 1-14 0v-2\"></path><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\"></line><line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMicComponent;
}());
var IconMic = /** @class */ (function () {
    function IconMic() {
    }
    IconMic.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMicComponent],
                    exports: [IconMicComponent]
                },] }
    ];
    return IconMic;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMinimize2Component = /** @class */ (function () {
    function IconMinimize2Component() {
    }
    IconMinimize2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-minimize-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-minimize-2\">\n    <polyline points=\"4 14 10 14 10 20\"></polyline><polyline points=\"20 10 14 10 14 4\"></polyline><line x1=\"14\" y1=\"10\" x2=\"21\" y2=\"3\"></line><line x1=\"3\" y1=\"21\" x2=\"10\" y2=\"14\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMinimize2Component;
}());
var IconMinimize2 = /** @class */ (function () {
    function IconMinimize2() {
    }
    IconMinimize2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMinimize2Component],
                    exports: [IconMinimize2Component]
                },] }
    ];
    return IconMinimize2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMinimizeComponent = /** @class */ (function () {
    function IconMinimizeComponent() {
    }
    IconMinimizeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-minimize',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-minimize\">\n    <path d=\"M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMinimizeComponent;
}());
var IconMinimize = /** @class */ (function () {
    function IconMinimize() {
    }
    IconMinimize.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMinimizeComponent],
                    exports: [IconMinimizeComponent]
                },] }
    ];
    return IconMinimize;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMinusCircleComponent = /** @class */ (function () {
    function IconMinusCircleComponent() {
    }
    IconMinusCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-minus-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-minus-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMinusCircleComponent;
}());
var IconMinusCircle = /** @class */ (function () {
    function IconMinusCircle() {
    }
    IconMinusCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMinusCircleComponent],
                    exports: [IconMinusCircleComponent]
                },] }
    ];
    return IconMinusCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMinusSquareComponent = /** @class */ (function () {
    function IconMinusSquareComponent() {
    }
    IconMinusSquareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-minus-square',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-minus-square\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMinusSquareComponent;
}());
var IconMinusSquare = /** @class */ (function () {
    function IconMinusSquare() {
    }
    IconMinusSquare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMinusSquareComponent],
                    exports: [IconMinusSquareComponent]
                },] }
    ];
    return IconMinusSquare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMinusComponent = /** @class */ (function () {
    function IconMinusComponent() {
    }
    IconMinusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-minus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-minus\">\n    <line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMinusComponent;
}());
var IconMinus = /** @class */ (function () {
    function IconMinus() {
    }
    IconMinus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMinusComponent],
                    exports: [IconMinusComponent]
                },] }
    ];
    return IconMinus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMonitorComponent = /** @class */ (function () {
    function IconMonitorComponent() {
    }
    IconMonitorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-monitor',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-monitor\">\n    <rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\" ry=\"2\"></rect><line x1=\"8\" y1=\"21\" x2=\"16\" y2=\"21\"></line><line x1=\"12\" y1=\"17\" x2=\"12\" y2=\"21\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMonitorComponent;
}());
var IconMonitor = /** @class */ (function () {
    function IconMonitor() {
    }
    IconMonitor.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMonitorComponent],
                    exports: [IconMonitorComponent]
                },] }
    ];
    return IconMonitor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMoonComponent = /** @class */ (function () {
    function IconMoonComponent() {
    }
    IconMoonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-moon',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-moon\">\n    <path d=\"M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMoonComponent;
}());
var IconMoon = /** @class */ (function () {
    function IconMoon() {
    }
    IconMoon.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMoonComponent],
                    exports: [IconMoonComponent]
                },] }
    ];
    return IconMoon;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMoreHorizontalComponent = /** @class */ (function () {
    function IconMoreHorizontalComponent() {
    }
    IconMoreHorizontalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-more-horizontal',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-more-horizontal\">\n    <circle cx=\"12\" cy=\"12\" r=\"1\"></circle><circle cx=\"19\" cy=\"12\" r=\"1\"></circle><circle cx=\"5\" cy=\"12\" r=\"1\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMoreHorizontalComponent;
}());
var IconMoreHorizontal = /** @class */ (function () {
    function IconMoreHorizontal() {
    }
    IconMoreHorizontal.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMoreHorizontalComponent],
                    exports: [IconMoreHorizontalComponent]
                },] }
    ];
    return IconMoreHorizontal;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMoreVerticalComponent = /** @class */ (function () {
    function IconMoreVerticalComponent() {
    }
    IconMoreVerticalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-more-vertical',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-more-vertical\">\n    <circle cx=\"12\" cy=\"12\" r=\"1\"></circle><circle cx=\"12\" cy=\"5\" r=\"1\"></circle><circle cx=\"12\" cy=\"19\" r=\"1\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMoreVerticalComponent;
}());
var IconMoreVertical = /** @class */ (function () {
    function IconMoreVertical() {
    }
    IconMoreVertical.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMoreVerticalComponent],
                    exports: [IconMoreVerticalComponent]
                },] }
    ];
    return IconMoreVertical;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMousePointerComponent = /** @class */ (function () {
    function IconMousePointerComponent() {
    }
    IconMousePointerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-mouse-pointer',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-mouse-pointer\">\n    <path d=\"M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z\"></path><path d=\"M13 13l6 6\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMousePointerComponent;
}());
var IconMousePointer = /** @class */ (function () {
    function IconMousePointer() {
    }
    IconMousePointer.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMousePointerComponent],
                    exports: [IconMousePointerComponent]
                },] }
    ];
    return IconMousePointer;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMoveComponent = /** @class */ (function () {
    function IconMoveComponent() {
    }
    IconMoveComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-move',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-move\">\n    <polyline points=\"5 9 2 12 5 15\"></polyline><polyline points=\"9 5 12 2 15 5\"></polyline><polyline points=\"15 19 12 22 9 19\"></polyline><polyline points=\"19 9 22 12 19 15\"></polyline><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\"></line><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"22\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMoveComponent;
}());
var IconMove = /** @class */ (function () {
    function IconMove() {
    }
    IconMove.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMoveComponent],
                    exports: [IconMoveComponent]
                },] }
    ];
    return IconMove;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconMusicComponent = /** @class */ (function () {
    function IconMusicComponent() {
    }
    IconMusicComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-music',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-music\">\n    <path d=\"M9 18V5l12-2v13\"></path><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><circle cx=\"18\" cy=\"16\" r=\"3\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconMusicComponent;
}());
var IconMusic = /** @class */ (function () {
    function IconMusic() {
    }
    IconMusic.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconMusicComponent],
                    exports: [IconMusicComponent]
                },] }
    ];
    return IconMusic;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconNavigation2Component = /** @class */ (function () {
    function IconNavigation2Component() {
    }
    IconNavigation2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-navigation-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-navigation-2\">\n    <polygon points=\"12 2 19 21 12 17 5 21 12 2\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconNavigation2Component;
}());
var IconNavigation2 = /** @class */ (function () {
    function IconNavigation2() {
    }
    IconNavigation2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconNavigation2Component],
                    exports: [IconNavigation2Component]
                },] }
    ];
    return IconNavigation2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconNavigationComponent = /** @class */ (function () {
    function IconNavigationComponent() {
    }
    IconNavigationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-navigation',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-navigation\">\n    <polygon points=\"3 11 22 2 13 21 11 13 3 11\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconNavigationComponent;
}());
var IconNavigation = /** @class */ (function () {
    function IconNavigation() {
    }
    IconNavigation.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconNavigationComponent],
                    exports: [IconNavigationComponent]
                },] }
    ];
    return IconNavigation;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconOctagonComponent = /** @class */ (function () {
    function IconOctagonComponent() {
    }
    IconOctagonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-octagon',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-octagon\">\n    <polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconOctagonComponent;
}());
var IconOctagon = /** @class */ (function () {
    function IconOctagon() {
    }
    IconOctagon.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconOctagonComponent],
                    exports: [IconOctagonComponent]
                },] }
    ];
    return IconOctagon;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPackageComponent = /** @class */ (function () {
    function IconPackageComponent() {
    }
    IconPackageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-package',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-package\">\n    <path d=\"M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z\"></path><polyline points=\"2.32 6.16 12 11 21.68 6.16\"></polyline><line x1=\"12\" y1=\"22.76\" x2=\"12\" y2=\"11\"></line><line x1=\"7\" y1=\"3.5\" x2=\"17\" y2=\"8.5\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPackageComponent;
}());
var IconPackage = /** @class */ (function () {
    function IconPackage() {
    }
    IconPackage.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPackageComponent],
                    exports: [IconPackageComponent]
                },] }
    ];
    return IconPackage;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPaperclipComponent = /** @class */ (function () {
    function IconPaperclipComponent() {
    }
    IconPaperclipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-paperclip',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-paperclip\">\n    <path d=\"M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPaperclipComponent;
}());
var IconPaperclip = /** @class */ (function () {
    function IconPaperclip() {
    }
    IconPaperclip.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPaperclipComponent],
                    exports: [IconPaperclipComponent]
                },] }
    ];
    return IconPaperclip;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPauseCircleComponent = /** @class */ (function () {
    function IconPauseCircleComponent() {
    }
    IconPauseCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-pause-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-pause-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"10\" y1=\"15\" x2=\"10\" y2=\"9\"></line><line x1=\"14\" y1=\"15\" x2=\"14\" y2=\"9\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPauseCircleComponent;
}());
var IconPauseCircle = /** @class */ (function () {
    function IconPauseCircle() {
    }
    IconPauseCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPauseCircleComponent],
                    exports: [IconPauseCircleComponent]
                },] }
    ];
    return IconPauseCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPauseComponent = /** @class */ (function () {
    function IconPauseComponent() {
    }
    IconPauseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-pause',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-pause\">\n    <rect x=\"6\" y=\"4\" width=\"4\" height=\"16\"></rect><rect x=\"14\" y=\"4\" width=\"4\" height=\"16\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPauseComponent;
}());
var IconPause = /** @class */ (function () {
    function IconPause() {
    }
    IconPause.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPauseComponent],
                    exports: [IconPauseComponent]
                },] }
    ];
    return IconPause;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPenToolComponent = /** @class */ (function () {
    function IconPenToolComponent() {
    }
    IconPenToolComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-pen-tool',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-pen-tool\">\n    <path d=\"M12 19l7-7 3 3-7 7-3-3z\"></path><path d=\"M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z\"></path><path d=\"M2 2l7.586 7.586\"></path><circle cx=\"11\" cy=\"11\" r=\"2\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPenToolComponent;
}());
var IconPenTool = /** @class */ (function () {
    function IconPenTool() {
    }
    IconPenTool.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPenToolComponent],
                    exports: [IconPenToolComponent]
                },] }
    ];
    return IconPenTool;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPercentComponent = /** @class */ (function () {
    function IconPercentComponent() {
    }
    IconPercentComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-percent',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-percent\">\n    <line x1=\"19\" y1=\"5\" x2=\"5\" y2=\"19\"></line><circle cx=\"6.5\" cy=\"6.5\" r=\"2.5\"></circle><circle cx=\"17.5\" cy=\"17.5\" r=\"2.5\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPercentComponent;
}());
var IconPercent = /** @class */ (function () {
    function IconPercent() {
    }
    IconPercent.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPercentComponent],
                    exports: [IconPercentComponent]
                },] }
    ];
    return IconPercent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneCallComponent = /** @class */ (function () {
    function IconPhoneCallComponent() {
    }
    IconPhoneCallComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone-call',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone-call\">\n    <path d=\"M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneCallComponent;
}());
var IconPhoneCall = /** @class */ (function () {
    function IconPhoneCall() {
    }
    IconPhoneCall.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneCallComponent],
                    exports: [IconPhoneCallComponent]
                },] }
    ];
    return IconPhoneCall;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneForwardedComponent = /** @class */ (function () {
    function IconPhoneForwardedComponent() {
    }
    IconPhoneForwardedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone-forwarded',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone-forwarded\">\n    <polyline points=\"19 1 23 5 19 9\"></polyline><line x1=\"15\" y1=\"5\" x2=\"23\" y2=\"5\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneForwardedComponent;
}());
var IconPhoneForwarded = /** @class */ (function () {
    function IconPhoneForwarded() {
    }
    IconPhoneForwarded.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneForwardedComponent],
                    exports: [IconPhoneForwardedComponent]
                },] }
    ];
    return IconPhoneForwarded;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneIncomingComponent = /** @class */ (function () {
    function IconPhoneIncomingComponent() {
    }
    IconPhoneIncomingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone-incoming',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone-incoming\">\n    <polyline points=\"16 2 16 8 22 8\"></polyline><line x1=\"23\" y1=\"1\" x2=\"16\" y2=\"8\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneIncomingComponent;
}());
var IconPhoneIncoming = /** @class */ (function () {
    function IconPhoneIncoming() {
    }
    IconPhoneIncoming.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneIncomingComponent],
                    exports: [IconPhoneIncomingComponent]
                },] }
    ];
    return IconPhoneIncoming;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneMissedComponent = /** @class */ (function () {
    function IconPhoneMissedComponent() {
    }
    IconPhoneMissedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone-missed',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone-missed\">\n    <line x1=\"23\" y1=\"1\" x2=\"17\" y2=\"7\"></line><line x1=\"17\" y1=\"1\" x2=\"23\" y2=\"7\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneMissedComponent;
}());
var IconPhoneMissed = /** @class */ (function () {
    function IconPhoneMissed() {
    }
    IconPhoneMissed.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneMissedComponent],
                    exports: [IconPhoneMissedComponent]
                },] }
    ];
    return IconPhoneMissed;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneOffComponent = /** @class */ (function () {
    function IconPhoneOffComponent() {
    }
    IconPhoneOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone-off\">\n    <path d=\"M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91\"></path><line x1=\"23\" y1=\"1\" x2=\"1\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneOffComponent;
}());
var IconPhoneOff = /** @class */ (function () {
    function IconPhoneOff() {
    }
    IconPhoneOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneOffComponent],
                    exports: [IconPhoneOffComponent]
                },] }
    ];
    return IconPhoneOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneOutgoingComponent = /** @class */ (function () {
    function IconPhoneOutgoingComponent() {
    }
    IconPhoneOutgoingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone-outgoing',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone-outgoing\">\n    <polyline points=\"23 7 23 1 17 1\"></polyline><line x1=\"16\" y1=\"8\" x2=\"23\" y2=\"1\"></line><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneOutgoingComponent;
}());
var IconPhoneOutgoing = /** @class */ (function () {
    function IconPhoneOutgoing() {
    }
    IconPhoneOutgoing.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneOutgoingComponent],
                    exports: [IconPhoneOutgoingComponent]
                },] }
    ];
    return IconPhoneOutgoing;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPhoneComponent = /** @class */ (function () {
    function IconPhoneComponent() {
    }
    IconPhoneComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-phone',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-phone\">\n    <path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPhoneComponent;
}());
var IconPhone = /** @class */ (function () {
    function IconPhone() {
    }
    IconPhone.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPhoneComponent],
                    exports: [IconPhoneComponent]
                },] }
    ];
    return IconPhone;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPieChartComponent = /** @class */ (function () {
    function IconPieChartComponent() {
    }
    IconPieChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-pie-chart',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-pie-chart\">\n    <path d=\"M21.21 15.89A10 10 0 1 1 8 2.83\"></path><path d=\"M22 12A10 10 0 0 0 12 2v10z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPieChartComponent;
}());
var IconPieChart = /** @class */ (function () {
    function IconPieChart() {
    }
    IconPieChart.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPieChartComponent],
                    exports: [IconPieChartComponent]
                },] }
    ];
    return IconPieChart;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPlayCircleComponent = /** @class */ (function () {
    function IconPlayCircleComponent() {
    }
    IconPlayCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-play-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-play-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polygon points=\"10 8 16 12 10 16 10 8\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPlayCircleComponent;
}());
var IconPlayCircle = /** @class */ (function () {
    function IconPlayCircle() {
    }
    IconPlayCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPlayCircleComponent],
                    exports: [IconPlayCircleComponent]
                },] }
    ];
    return IconPlayCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPlayComponent = /** @class */ (function () {
    function IconPlayComponent() {
    }
    IconPlayComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-play',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-play\">\n    <polygon points=\"5 3 19 12 5 21 5 3\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPlayComponent;
}());
var IconPlay = /** @class */ (function () {
    function IconPlay() {
    }
    IconPlay.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPlayComponent],
                    exports: [IconPlayComponent]
                },] }
    ];
    return IconPlay;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPlusCircleComponent = /** @class */ (function () {
    function IconPlusCircleComponent() {
    }
    IconPlusCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-plus-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-plus-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPlusCircleComponent;
}());
var IconPlusCircle = /** @class */ (function () {
    function IconPlusCircle() {
    }
    IconPlusCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPlusCircleComponent],
                    exports: [IconPlusCircleComponent]
                },] }
    ];
    return IconPlusCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPlusSquareComponent = /** @class */ (function () {
    function IconPlusSquareComponent() {
    }
    IconPlusSquareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-plus-square',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-plus-square\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPlusSquareComponent;
}());
var IconPlusSquare = /** @class */ (function () {
    function IconPlusSquare() {
    }
    IconPlusSquare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPlusSquareComponent],
                    exports: [IconPlusSquareComponent]
                },] }
    ];
    return IconPlusSquare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPlusComponent = /** @class */ (function () {
    function IconPlusComponent() {
    }
    IconPlusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-plus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-plus\">\n    <line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"></line><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPlusComponent;
}());
var IconPlus = /** @class */ (function () {
    function IconPlus() {
    }
    IconPlus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPlusComponent],
                    exports: [IconPlusComponent]
                },] }
    ];
    return IconPlus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPocketComponent = /** @class */ (function () {
    function IconPocketComponent() {
    }
    IconPocketComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-pocket',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-pocket\">\n    <path d=\"M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z\"></path><polyline points=\"8 10 12 14 16 10\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPocketComponent;
}());
var IconPocket = /** @class */ (function () {
    function IconPocket() {
    }
    IconPocket.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPocketComponent],
                    exports: [IconPocketComponent]
                },] }
    ];
    return IconPocket;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPowerComponent = /** @class */ (function () {
    function IconPowerComponent() {
    }
    IconPowerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-power',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-power\">\n    <path d=\"M18.36 6.64a9 9 0 1 1-12.73 0\"></path><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPowerComponent;
}());
var IconPower = /** @class */ (function () {
    function IconPower() {
    }
    IconPower.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPowerComponent],
                    exports: [IconPowerComponent]
                },] }
    ];
    return IconPower;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconPrinterComponent = /** @class */ (function () {
    function IconPrinterComponent() {
    }
    IconPrinterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-printer',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-printer\">\n    <polyline points=\"6 9 6 2 18 2 18 9\"></polyline><path d=\"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2\"></path><rect x=\"6\" y=\"14\" width=\"12\" height=\"8\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconPrinterComponent;
}());
var IconPrinter = /** @class */ (function () {
    function IconPrinter() {
    }
    IconPrinter.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconPrinterComponent],
                    exports: [IconPrinterComponent]
                },] }
    ];
    return IconPrinter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRadioComponent = /** @class */ (function () {
    function IconRadioComponent() {
    }
    IconRadioComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-radio',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-radio\">\n    <circle cx=\"12\" cy=\"12\" r=\"2\"></circle><path d=\"M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRadioComponent;
}());
var IconRadio = /** @class */ (function () {
    function IconRadio() {
    }
    IconRadio.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRadioComponent],
                    exports: [IconRadioComponent]
                },] }
    ];
    return IconRadio;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRefreshCcwComponent = /** @class */ (function () {
    function IconRefreshCcwComponent() {
    }
    IconRefreshCcwComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-refresh-ccw',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-refresh-ccw\">\n    <polyline points=\"1 4 1 10 7 10\"></polyline><polyline points=\"23 20 23 14 17 14\"></polyline><path d=\"M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRefreshCcwComponent;
}());
var IconRefreshCcw = /** @class */ (function () {
    function IconRefreshCcw() {
    }
    IconRefreshCcw.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRefreshCcwComponent],
                    exports: [IconRefreshCcwComponent]
                },] }
    ];
    return IconRefreshCcw;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRefreshCwComponent = /** @class */ (function () {
    function IconRefreshCwComponent() {
    }
    IconRefreshCwComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-refresh-cw',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-refresh-cw\">\n    <polyline points=\"23 4 23 10 17 10\"></polyline><polyline points=\"1 20 1 14 7 14\"></polyline><path d=\"M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRefreshCwComponent;
}());
var IconRefreshCw = /** @class */ (function () {
    function IconRefreshCw() {
    }
    IconRefreshCw.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRefreshCwComponent],
                    exports: [IconRefreshCwComponent]
                },] }
    ];
    return IconRefreshCw;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRepeatComponent = /** @class */ (function () {
    function IconRepeatComponent() {
    }
    IconRepeatComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-repeat',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-repeat\">\n    <polyline points=\"17 1 21 5 17 9\"></polyline><path d=\"M3 11V9a4 4 0 0 1 4-4h14\"></path><polyline points=\"7 23 3 19 7 15\"></polyline><path d=\"M21 13v2a4 4 0 0 1-4 4H3\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRepeatComponent;
}());
var IconRepeat = /** @class */ (function () {
    function IconRepeat() {
    }
    IconRepeat.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRepeatComponent],
                    exports: [IconRepeatComponent]
                },] }
    ];
    return IconRepeat;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRewindComponent = /** @class */ (function () {
    function IconRewindComponent() {
    }
    IconRewindComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-rewind',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-rewind\">\n    <polygon points=\"11 19 2 12 11 5 11 19\"></polygon><polygon points=\"22 19 13 12 22 5 22 19\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRewindComponent;
}());
var IconRewind = /** @class */ (function () {
    function IconRewind() {
    }
    IconRewind.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRewindComponent],
                    exports: [IconRewindComponent]
                },] }
    ];
    return IconRewind;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRotateCcwComponent = /** @class */ (function () {
    function IconRotateCcwComponent() {
    }
    IconRotateCcwComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-rotate-ccw',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-rotate-ccw\">\n    <polyline points=\"1 4 1 10 7 10\"></polyline><path d=\"M3.51 15a9 9 0 1 0 2.13-9.36L1 10\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRotateCcwComponent;
}());
var IconRotateCcw = /** @class */ (function () {
    function IconRotateCcw() {
    }
    IconRotateCcw.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRotateCcwComponent],
                    exports: [IconRotateCcwComponent]
                },] }
    ];
    return IconRotateCcw;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRotateCwComponent = /** @class */ (function () {
    function IconRotateCwComponent() {
    }
    IconRotateCwComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-rotate-cw',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-rotate-cw\">\n    <polyline points=\"23 4 23 10 17 10\"></polyline><path d=\"M20.49 15a9 9 0 1 1-2.12-9.36L23 10\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRotateCwComponent;
}());
var IconRotateCw = /** @class */ (function () {
    function IconRotateCw() {
    }
    IconRotateCw.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRotateCwComponent],
                    exports: [IconRotateCwComponent]
                },] }
    ];
    return IconRotateCw;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconRssComponent = /** @class */ (function () {
    function IconRssComponent() {
    }
    IconRssComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-rss',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-rss\">\n    <path d=\"M4 11a9 9 0 0 1 9 9\"></path><path d=\"M4 4a16 16 0 0 1 16 16\"></path><circle cx=\"5\" cy=\"19\" r=\"1\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconRssComponent;
}());
var IconRss = /** @class */ (function () {
    function IconRss() {
    }
    IconRss.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconRssComponent],
                    exports: [IconRssComponent]
                },] }
    ];
    return IconRss;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSaveComponent = /** @class */ (function () {
    function IconSaveComponent() {
    }
    IconSaveComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-save',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-save\">\n    <path d=\"M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z\"></path><polyline points=\"17 21 17 13 7 13 7 21\"></polyline><polyline points=\"7 3 7 8 15 8\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSaveComponent;
}());
var IconSave = /** @class */ (function () {
    function IconSave() {
    }
    IconSave.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSaveComponent],
                    exports: [IconSaveComponent]
                },] }
    ];
    return IconSave;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconScissorsComponent = /** @class */ (function () {
    function IconScissorsComponent() {
    }
    IconScissorsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-scissors',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-scissors\">\n    <circle cx=\"6\" cy=\"6\" r=\"3\"></circle><circle cx=\"6\" cy=\"18\" r=\"3\"></circle><line x1=\"20\" y1=\"4\" x2=\"8.12\" y2=\"15.88\"></line><line x1=\"14.47\" y1=\"14.48\" x2=\"20\" y2=\"20\"></line><line x1=\"8.12\" y1=\"8.12\" x2=\"12\" y2=\"12\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconScissorsComponent;
}());
var IconScissors = /** @class */ (function () {
    function IconScissors() {
    }
    IconScissors.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconScissorsComponent],
                    exports: [IconScissorsComponent]
                },] }
    ];
    return IconScissors;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSearchComponent = /** @class */ (function () {
    function IconSearchComponent() {
    }
    IconSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-search',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-search\">\n    <circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSearchComponent;
}());
var IconSearch = /** @class */ (function () {
    function IconSearch() {
    }
    IconSearch.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSearchComponent],
                    exports: [IconSearchComponent]
                },] }
    ];
    return IconSearch;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSendComponent = /** @class */ (function () {
    function IconSendComponent() {
    }
    IconSendComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-send',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-send\">\n    <line x1=\"22\" y1=\"2\" x2=\"11\" y2=\"13\"></line><polygon points=\"22 2 15 22 11 13 2 9 22 2\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSendComponent;
}());
var IconSend = /** @class */ (function () {
    function IconSend() {
    }
    IconSend.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSendComponent],
                    exports: [IconSendComponent]
                },] }
    ];
    return IconSend;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconServerComponent = /** @class */ (function () {
    function IconServerComponent() {
    }
    IconServerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-server',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-server\">\n    <rect x=\"2\" y=\"2\" width=\"20\" height=\"8\" rx=\"2\" ry=\"2\"></rect><rect x=\"2\" y=\"14\" width=\"20\" height=\"8\" rx=\"2\" ry=\"2\"></rect><line x1=\"6\" y1=\"6\" x2=\"6\" y2=\"6\"></line><line x1=\"6\" y1=\"18\" x2=\"6\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconServerComponent;
}());
var IconServer = /** @class */ (function () {
    function IconServer() {
    }
    IconServer.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconServerComponent],
                    exports: [IconServerComponent]
                },] }
    ];
    return IconServer;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSettingsComponent = /** @class */ (function () {
    function IconSettingsComponent() {
    }
    IconSettingsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-settings',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-settings\">\n    <circle cx=\"12\" cy=\"12\" r=\"3\"></circle><path d=\"M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSettingsComponent;
}());
var IconSettings = /** @class */ (function () {
    function IconSettings() {
    }
    IconSettings.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSettingsComponent],
                    exports: [IconSettingsComponent]
                },] }
    ];
    return IconSettings;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShare2Component = /** @class */ (function () {
    function IconShare2Component() {
    }
    IconShare2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-share-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-share-2\">\n    <circle cx=\"18\" cy=\"5\" r=\"3\"></circle><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"19\" r=\"3\"></circle><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"></line><line x1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShare2Component;
}());
var IconShare2 = /** @class */ (function () {
    function IconShare2() {
    }
    IconShare2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShare2Component],
                    exports: [IconShare2Component]
                },] }
    ];
    return IconShare2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShareComponent = /** @class */ (function () {
    function IconShareComponent() {
    }
    IconShareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-share',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-share\">\n    <path d=\"M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8\"></path><polyline points=\"16 6 12 2 8 6\"></polyline><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShareComponent;
}());
var IconShare = /** @class */ (function () {
    function IconShare() {
    }
    IconShare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShareComponent],
                    exports: [IconShareComponent]
                },] }
    ];
    return IconShare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShieldOffComponent = /** @class */ (function () {
    function IconShieldOffComponent() {
    }
    IconShieldOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-shield-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-shield-off\">\n    <path d=\"M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18\"></path><path d=\"M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShieldOffComponent;
}());
var IconShieldOff = /** @class */ (function () {
    function IconShieldOff() {
    }
    IconShieldOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShieldOffComponent],
                    exports: [IconShieldOffComponent]
                },] }
    ];
    return IconShieldOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShieldComponent = /** @class */ (function () {
    function IconShieldComponent() {
    }
    IconShieldComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-shield',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-shield\">\n    <path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShieldComponent;
}());
var IconShield = /** @class */ (function () {
    function IconShield() {
    }
    IconShield.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShieldComponent],
                    exports: [IconShieldComponent]
                },] }
    ];
    return IconShield;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShoppingBagComponent = /** @class */ (function () {
    function IconShoppingBagComponent() {
    }
    IconShoppingBagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-shopping-bag',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-shopping-bag\">\n    <path d=\"M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z\"></path><line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\"></line><path d=\"M16 10a4 4 0 0 1-8 0\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShoppingBagComponent;
}());
var IconShoppingBag = /** @class */ (function () {
    function IconShoppingBag() {
    }
    IconShoppingBag.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShoppingBagComponent],
                    exports: [IconShoppingBagComponent]
                },] }
    ];
    return IconShoppingBag;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShoppingCartComponent = /** @class */ (function () {
    function IconShoppingCartComponent() {
    }
    IconShoppingCartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-shopping-cart',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-shopping-cart\">\n    <circle cx=\"9\" cy=\"21\" r=\"1\"></circle><circle cx=\"20\" cy=\"21\" r=\"1\"></circle><path d=\"M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShoppingCartComponent;
}());
var IconShoppingCart = /** @class */ (function () {
    function IconShoppingCart() {
    }
    IconShoppingCart.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShoppingCartComponent],
                    exports: [IconShoppingCartComponent]
                },] }
    ];
    return IconShoppingCart;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconShuffleComponent = /** @class */ (function () {
    function IconShuffleComponent() {
    }
    IconShuffleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-shuffle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-shuffle\">\n    <polyline points=\"16 3 21 3 21 8\"></polyline><line x1=\"4\" y1=\"20\" x2=\"21\" y2=\"3\"></line><polyline points=\"21 16 21 21 16 21\"></polyline><line x1=\"15\" y1=\"15\" x2=\"21\" y2=\"21\"></line><line x1=\"4\" y1=\"4\" x2=\"9\" y2=\"9\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconShuffleComponent;
}());
var IconShuffle = /** @class */ (function () {
    function IconShuffle() {
    }
    IconShuffle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconShuffleComponent],
                    exports: [IconShuffleComponent]
                },] }
    ];
    return IconShuffle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSidebarComponent = /** @class */ (function () {
    function IconSidebarComponent() {
    }
    IconSidebarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-sidebar',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-sidebar\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"9\" y1=\"3\" x2=\"9\" y2=\"21\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSidebarComponent;
}());
var IconSidebar = /** @class */ (function () {
    function IconSidebar() {
    }
    IconSidebar.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSidebarComponent],
                    exports: [IconSidebarComponent]
                },] }
    ];
    return IconSidebar;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSkipBackComponent = /** @class */ (function () {
    function IconSkipBackComponent() {
    }
    IconSkipBackComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-skip-back',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-skip-back\">\n    <polygon points=\"19 20 9 12 19 4 19 20\"></polygon><line x1=\"5\" y1=\"19\" x2=\"5\" y2=\"5\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSkipBackComponent;
}());
var IconSkipBack = /** @class */ (function () {
    function IconSkipBack() {
    }
    IconSkipBack.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSkipBackComponent],
                    exports: [IconSkipBackComponent]
                },] }
    ];
    return IconSkipBack;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSkipForwardComponent = /** @class */ (function () {
    function IconSkipForwardComponent() {
    }
    IconSkipForwardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-skip-forward',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-skip-forward\">\n    <polygon points=\"5 4 15 12 5 20 5 4\"></polygon><line x1=\"19\" y1=\"5\" x2=\"19\" y2=\"19\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSkipForwardComponent;
}());
var IconSkipForward = /** @class */ (function () {
    function IconSkipForward() {
    }
    IconSkipForward.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSkipForwardComponent],
                    exports: [IconSkipForwardComponent]
                },] }
    ];
    return IconSkipForward;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSlackComponent = /** @class */ (function () {
    function IconSlackComponent() {
    }
    IconSlackComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-slack',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-slack\">\n    <path d=\"M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z\"></path><path d=\"M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z\"></path><path d=\"M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z\"></path><path d=\"M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z\"></path><path d=\"M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z\"></path><path d=\"M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z\"></path><path d=\"M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z\"></path><path d=\"M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSlackComponent;
}());
var IconSlack = /** @class */ (function () {
    function IconSlack() {
    }
    IconSlack.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSlackComponent],
                    exports: [IconSlackComponent]
                },] }
    ];
    return IconSlack;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSlashComponent = /** @class */ (function () {
    function IconSlashComponent() {
    }
    IconSlashComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-slash',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-slash\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"4.93\" y1=\"4.93\" x2=\"19.07\" y2=\"19.07\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSlashComponent;
}());
var IconSlash = /** @class */ (function () {
    function IconSlash() {
    }
    IconSlash.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSlashComponent],
                    exports: [IconSlashComponent]
                },] }
    ];
    return IconSlash;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSlidersComponent = /** @class */ (function () {
    function IconSlidersComponent() {
    }
    IconSlidersComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-sliders',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-sliders\">\n    <line x1=\"4\" y1=\"21\" x2=\"4\" y2=\"14\"></line><line x1=\"4\" y1=\"10\" x2=\"4\" y2=\"3\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"3\"></line><line x1=\"20\" y1=\"21\" x2=\"20\" y2=\"16\"></line><line x1=\"20\" y1=\"12\" x2=\"20\" y2=\"3\"></line><line x1=\"1\" y1=\"14\" x2=\"7\" y2=\"14\"></line><line x1=\"9\" y1=\"8\" x2=\"15\" y2=\"8\"></line><line x1=\"17\" y1=\"16\" x2=\"23\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSlidersComponent;
}());
var IconSliders = /** @class */ (function () {
    function IconSliders() {
    }
    IconSliders.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSlidersComponent],
                    exports: [IconSlidersComponent]
                },] }
    ];
    return IconSliders;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSmartphoneComponent = /** @class */ (function () {
    function IconSmartphoneComponent() {
    }
    IconSmartphoneComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-smartphone',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-smartphone\">\n    <rect x=\"5\" y=\"2\" width=\"14\" height=\"20\" rx=\"2\" ry=\"2\"></rect><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSmartphoneComponent;
}());
var IconSmartphone = /** @class */ (function () {
    function IconSmartphone() {
    }
    IconSmartphone.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSmartphoneComponent],
                    exports: [IconSmartphoneComponent]
                },] }
    ];
    return IconSmartphone;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSmileComponent = /** @class */ (function () {
    function IconSmileComponent() {
    }
    IconSmileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-smile',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-smile\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M8 14s1.5 2 4 2 4-2 4-2\"></path><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\"></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSmileComponent;
}());
var IconSmile = /** @class */ (function () {
    function IconSmile() {
    }
    IconSmile.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSmileComponent],
                    exports: [IconSmileComponent]
                },] }
    ];
    return IconSmile;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSpeakerComponent = /** @class */ (function () {
    function IconSpeakerComponent() {
    }
    IconSpeakerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-speaker',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-speaker\">\n    <rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\"></rect><circle cx=\"12\" cy=\"14\" r=\"4\"></circle><line x1=\"12\" y1=\"6\" x2=\"12\" y2=\"6\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSpeakerComponent;
}());
var IconSpeaker = /** @class */ (function () {
    function IconSpeaker() {
    }
    IconSpeaker.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSpeakerComponent],
                    exports: [IconSpeakerComponent]
                },] }
    ];
    return IconSpeaker;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSquareComponent = /** @class */ (function () {
    function IconSquareComponent() {
    }
    IconSquareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-square',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-square\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSquareComponent;
}());
var IconSquare = /** @class */ (function () {
    function IconSquare() {
    }
    IconSquare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSquareComponent],
                    exports: [IconSquareComponent]
                },] }
    ];
    return IconSquare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconStarComponent = /** @class */ (function () {
    function IconStarComponent() {
    }
    IconStarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-star',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-star\">\n    <polygon points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconStarComponent;
}());
var IconStar = /** @class */ (function () {
    function IconStar() {
    }
    IconStar.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconStarComponent],
                    exports: [IconStarComponent]
                },] }
    ];
    return IconStar;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconStopCircleComponent = /** @class */ (function () {
    function IconStopCircleComponent() {
    }
    IconStopCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-stop-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-stop-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconStopCircleComponent;
}());
var IconStopCircle = /** @class */ (function () {
    function IconStopCircle() {
    }
    IconStopCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconStopCircleComponent],
                    exports: [IconStopCircleComponent]
                },] }
    ];
    return IconStopCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSunComponent = /** @class */ (function () {
    function IconSunComponent() {
    }
    IconSunComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-sun',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-sun\">\n    <circle cx=\"12\" cy=\"12\" r=\"5\"></circle><line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"3\"></line><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\"></line><line x1=\"4.22\" y1=\"4.22\" x2=\"5.64\" y2=\"5.64\"></line><line x1=\"18.36\" y1=\"18.36\" x2=\"19.78\" y2=\"19.78\"></line><line x1=\"1\" y1=\"12\" x2=\"3\" y2=\"12\"></line><line x1=\"21\" y1=\"12\" x2=\"23\" y2=\"12\"></line><line x1=\"4.22\" y1=\"19.78\" x2=\"5.64\" y2=\"18.36\"></line><line x1=\"18.36\" y1=\"5.64\" x2=\"19.78\" y2=\"4.22\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSunComponent;
}());
var IconSun = /** @class */ (function () {
    function IconSun() {
    }
    IconSun.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSunComponent],
                    exports: [IconSunComponent]
                },] }
    ];
    return IconSun;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSunriseComponent = /** @class */ (function () {
    function IconSunriseComponent() {
    }
    IconSunriseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-sunrise',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-sunrise\">\n    <path d=\"M17 18a5 5 0 0 0-10 0\"></path><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"9\"></line><line x1=\"4.22\" y1=\"10.22\" x2=\"5.64\" y2=\"11.64\"></line><line x1=\"1\" y1=\"18\" x2=\"3\" y2=\"18\"></line><line x1=\"21\" y1=\"18\" x2=\"23\" y2=\"18\"></line><line x1=\"18.36\" y1=\"11.64\" x2=\"19.78\" y2=\"10.22\"></line><line x1=\"23\" y1=\"22\" x2=\"1\" y2=\"22\"></line><polyline points=\"8 6 12 2 16 6\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSunriseComponent;
}());
var IconSunrise = /** @class */ (function () {
    function IconSunrise() {
    }
    IconSunrise.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSunriseComponent],
                    exports: [IconSunriseComponent]
                },] }
    ];
    return IconSunrise;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconSunsetComponent = /** @class */ (function () {
    function IconSunsetComponent() {
    }
    IconSunsetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-sunset',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-sunset\">\n    <path d=\"M17 18a5 5 0 0 0-10 0\"></path><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"2\"></line><line x1=\"4.22\" y1=\"10.22\" x2=\"5.64\" y2=\"11.64\"></line><line x1=\"1\" y1=\"18\" x2=\"3\" y2=\"18\"></line><line x1=\"21\" y1=\"18\" x2=\"23\" y2=\"18\"></line><line x1=\"18.36\" y1=\"11.64\" x2=\"19.78\" y2=\"10.22\"></line><line x1=\"23\" y1=\"22\" x2=\"1\" y2=\"22\"></line><polyline points=\"16 5 12 9 8 5\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconSunsetComponent;
}());
var IconSunset = /** @class */ (function () {
    function IconSunset() {
    }
    IconSunset.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconSunsetComponent],
                    exports: [IconSunsetComponent]
                },] }
    ];
    return IconSunset;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTabletComponent = /** @class */ (function () {
    function IconTabletComponent() {
    }
    IconTabletComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-tablet',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-tablet\">\n    <rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\" ry=\"2\" transform=\"rotate(180 12 12)\"></rect><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTabletComponent;
}());
var IconTablet = /** @class */ (function () {
    function IconTablet() {
    }
    IconTablet.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTabletComponent],
                    exports: [IconTabletComponent]
                },] }
    ];
    return IconTablet;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTagComponent = /** @class */ (function () {
    function IconTagComponent() {
    }
    IconTagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-tag',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-tag\">\n    <path d=\"M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z\"></path><line x1=\"7\" y1=\"7\" x2=\"7\" y2=\"7\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTagComponent;
}());
var IconTag = /** @class */ (function () {
    function IconTag() {
    }
    IconTag.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTagComponent],
                    exports: [IconTagComponent]
                },] }
    ];
    return IconTag;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTargetComponent = /** @class */ (function () {
    function IconTargetComponent() {
    }
    IconTargetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-target',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-target\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><circle cx=\"12\" cy=\"12\" r=\"6\"></circle><circle cx=\"12\" cy=\"12\" r=\"2\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTargetComponent;
}());
var IconTarget = /** @class */ (function () {
    function IconTarget() {
    }
    IconTarget.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTargetComponent],
                    exports: [IconTargetComponent]
                },] }
    ];
    return IconTarget;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTerminalComponent = /** @class */ (function () {
    function IconTerminalComponent() {
    }
    IconTerminalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-terminal',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-terminal\">\n    <polyline points=\"4 17 10 11 4 5\"></polyline><line x1=\"12\" y1=\"19\" x2=\"20\" y2=\"19\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTerminalComponent;
}());
var IconTerminal = /** @class */ (function () {
    function IconTerminal() {
    }
    IconTerminal.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTerminalComponent],
                    exports: [IconTerminalComponent]
                },] }
    ];
    return IconTerminal;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconThermometerComponent = /** @class */ (function () {
    function IconThermometerComponent() {
    }
    IconThermometerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-thermometer',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-thermometer\">\n    <path d=\"M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconThermometerComponent;
}());
var IconThermometer = /** @class */ (function () {
    function IconThermometer() {
    }
    IconThermometer.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconThermometerComponent],
                    exports: [IconThermometerComponent]
                },] }
    ];
    return IconThermometer;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconThumbsDownComponent = /** @class */ (function () {
    function IconThumbsDownComponent() {
    }
    IconThumbsDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-thumbs-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-thumbs-down\">\n    <path d=\"M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconThumbsDownComponent;
}());
var IconThumbsDown = /** @class */ (function () {
    function IconThumbsDown() {
    }
    IconThumbsDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconThumbsDownComponent],
                    exports: [IconThumbsDownComponent]
                },] }
    ];
    return IconThumbsDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconThumbsUpComponent = /** @class */ (function () {
    function IconThumbsUpComponent() {
    }
    IconThumbsUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-thumbs-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-thumbs-up\">\n    <path d=\"M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconThumbsUpComponent;
}());
var IconThumbsUp = /** @class */ (function () {
    function IconThumbsUp() {
    }
    IconThumbsUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconThumbsUpComponent],
                    exports: [IconThumbsUpComponent]
                },] }
    ];
    return IconThumbsUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconToggleLeftComponent = /** @class */ (function () {
    function IconToggleLeftComponent() {
    }
    IconToggleLeftComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-toggle-left',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-toggle-left\">\n    <rect x=\"1\" y=\"5\" width=\"22\" height=\"14\" rx=\"7\" ry=\"7\"></rect><circle cx=\"8\" cy=\"12\" r=\"3\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconToggleLeftComponent;
}());
var IconToggleLeft = /** @class */ (function () {
    function IconToggleLeft() {
    }
    IconToggleLeft.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconToggleLeftComponent],
                    exports: [IconToggleLeftComponent]
                },] }
    ];
    return IconToggleLeft;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconToggleRightComponent = /** @class */ (function () {
    function IconToggleRightComponent() {
    }
    IconToggleRightComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-toggle-right',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-toggle-right\">\n    <rect x=\"1\" y=\"5\" width=\"22\" height=\"14\" rx=\"7\" ry=\"7\"></rect><circle cx=\"16\" cy=\"12\" r=\"3\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconToggleRightComponent;
}());
var IconToggleRight = /** @class */ (function () {
    function IconToggleRight() {
    }
    IconToggleRight.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconToggleRightComponent],
                    exports: [IconToggleRightComponent]
                },] }
    ];
    return IconToggleRight;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTrash2Component = /** @class */ (function () {
    function IconTrash2Component() {
    }
    IconTrash2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-trash-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-trash-2\">\n    <polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\"></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTrash2Component;
}());
var IconTrash2 = /** @class */ (function () {
    function IconTrash2() {
    }
    IconTrash2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTrash2Component],
                    exports: [IconTrash2Component]
                },] }
    ];
    return IconTrash2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTrashComponent = /** @class */ (function () {
    function IconTrashComponent() {
    }
    IconTrashComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-trash',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-trash\">\n    <polyline points=\"3 6 5 6 21 6\"></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTrashComponent;
}());
var IconTrash = /** @class */ (function () {
    function IconTrash() {
    }
    IconTrash.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTrashComponent],
                    exports: [IconTrashComponent]
                },] }
    ];
    return IconTrash;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTrelloComponent = /** @class */ (function () {
    function IconTrelloComponent() {
    }
    IconTrelloComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-trello',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-trello\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><rect x=\"7\" y=\"7\" width=\"3\" height=\"9\"></rect><rect x=\"14\" y=\"7\" width=\"3\" height=\"5\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTrelloComponent;
}());
var IconTrello = /** @class */ (function () {
    function IconTrello() {
    }
    IconTrello.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTrelloComponent],
                    exports: [IconTrelloComponent]
                },] }
    ];
    return IconTrello;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTrendingDownComponent = /** @class */ (function () {
    function IconTrendingDownComponent() {
    }
    IconTrendingDownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-trending-down',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-trending-down\">\n    <polyline points=\"23 18 13.5 8.5 8.5 13.5 1 6\"></polyline><polyline points=\"17 18 23 18 23 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTrendingDownComponent;
}());
var IconTrendingDown = /** @class */ (function () {
    function IconTrendingDown() {
    }
    IconTrendingDown.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTrendingDownComponent],
                    exports: [IconTrendingDownComponent]
                },] }
    ];
    return IconTrendingDown;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTrendingUpComponent = /** @class */ (function () {
    function IconTrendingUpComponent() {
    }
    IconTrendingUpComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-trending-up',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-trending-up\">\n    <polyline points=\"23 6 13.5 15.5 8.5 10.5 1 18\"></polyline><polyline points=\"17 6 23 6 23 12\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTrendingUpComponent;
}());
var IconTrendingUp = /** @class */ (function () {
    function IconTrendingUp() {
    }
    IconTrendingUp.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTrendingUpComponent],
                    exports: [IconTrendingUpComponent]
                },] }
    ];
    return IconTrendingUp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTriangleComponent = /** @class */ (function () {
    function IconTriangleComponent() {
    }
    IconTriangleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-triangle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-triangle\">\n    <path d=\"M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTriangleComponent;
}());
var IconTriangle = /** @class */ (function () {
    function IconTriangle() {
    }
    IconTriangle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTriangleComponent],
                    exports: [IconTriangleComponent]
                },] }
    ];
    return IconTriangle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTruckComponent = /** @class */ (function () {
    function IconTruckComponent() {
    }
    IconTruckComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-truck',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-truck\">\n    <rect x=\"1\" y=\"3\" width=\"15\" height=\"13\"></rect><polygon points=\"16 8 20 8 23 11 23 16 16 16 16 8\"></polygon><circle cx=\"5.5\" cy=\"18.5\" r=\"2.5\"></circle><circle cx=\"18.5\" cy=\"18.5\" r=\"2.5\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTruckComponent;
}());
var IconTruck = /** @class */ (function () {
    function IconTruck() {
    }
    IconTruck.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTruckComponent],
                    exports: [IconTruckComponent]
                },] }
    ];
    return IconTruck;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTvComponent = /** @class */ (function () {
    function IconTvComponent() {
    }
    IconTvComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-tv',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-tv\">\n    <rect x=\"2\" y=\"7\" width=\"20\" height=\"15\" rx=\"2\" ry=\"2\"></rect><polyline points=\"17 2 12 7 7 2\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTvComponent;
}());
var IconTv = /** @class */ (function () {
    function IconTv() {
    }
    IconTv.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTvComponent],
                    exports: [IconTvComponent]
                },] }
    ];
    return IconTv;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTwitterComponent = /** @class */ (function () {
    function IconTwitterComponent() {
    }
    IconTwitterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-twitter',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-twitter\">\n    <path d=\"M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTwitterComponent;
}());
var IconTwitter = /** @class */ (function () {
    function IconTwitter() {
    }
    IconTwitter.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTwitterComponent],
                    exports: [IconTwitterComponent]
                },] }
    ];
    return IconTwitter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconTypeComponent = /** @class */ (function () {
    function IconTypeComponent() {
    }
    IconTypeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-type',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-type\">\n    <polyline points=\"4 7 4 4 20 4 20 7\"></polyline><line x1=\"9\" y1=\"20\" x2=\"15\" y2=\"20\"></line><line x1=\"12\" y1=\"4\" x2=\"12\" y2=\"20\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconTypeComponent;
}());
var IconType = /** @class */ (function () {
    function IconType() {
    }
    IconType.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconTypeComponent],
                    exports: [IconTypeComponent]
                },] }
    ];
    return IconType;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUmbrellaComponent = /** @class */ (function () {
    function IconUmbrellaComponent() {
    }
    IconUmbrellaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-umbrella',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-umbrella\">\n    <path d=\"M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUmbrellaComponent;
}());
var IconUmbrella = /** @class */ (function () {
    function IconUmbrella() {
    }
    IconUmbrella.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUmbrellaComponent],
                    exports: [IconUmbrellaComponent]
                },] }
    ];
    return IconUmbrella;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUnderlineComponent = /** @class */ (function () {
    function IconUnderlineComponent() {
    }
    IconUnderlineComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-underline',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-underline\">\n    <path d=\"M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3\"></path><line x1=\"4\" y1=\"21\" x2=\"20\" y2=\"21\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUnderlineComponent;
}());
var IconUnderline = /** @class */ (function () {
    function IconUnderline() {
    }
    IconUnderline.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUnderlineComponent],
                    exports: [IconUnderlineComponent]
                },] }
    ];
    return IconUnderline;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUnlockComponent = /** @class */ (function () {
    function IconUnlockComponent() {
    }
    IconUnlockComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-unlock',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-unlock\">\n    <rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\"></rect><path d=\"M7 11V7a5 5 0 0 1 9.9-1\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUnlockComponent;
}());
var IconUnlock = /** @class */ (function () {
    function IconUnlock() {
    }
    IconUnlock.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUnlockComponent],
                    exports: [IconUnlockComponent]
                },] }
    ];
    return IconUnlock;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUploadCloudComponent = /** @class */ (function () {
    function IconUploadCloudComponent() {
    }
    IconUploadCloudComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-upload-cloud',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-upload-cloud\">\n    <polyline points=\"16 16 12 12 8 16\"></polyline><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"21\"></line><path d=\"M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3\"></path><polyline points=\"16 16 12 12 8 16\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUploadCloudComponent;
}());
var IconUploadCloud = /** @class */ (function () {
    function IconUploadCloud() {
    }
    IconUploadCloud.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUploadCloudComponent],
                    exports: [IconUploadCloudComponent]
                },] }
    ];
    return IconUploadCloud;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUploadComponent = /** @class */ (function () {
    function IconUploadComponent() {
    }
    IconUploadComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-upload',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-upload\">\n    <path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"></path><polyline points=\"17 8 12 3 7 8\"></polyline><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUploadComponent;
}());
var IconUpload = /** @class */ (function () {
    function IconUpload() {
    }
    IconUpload.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUploadComponent],
                    exports: [IconUploadComponent]
                },] }
    ];
    return IconUpload;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUserCheckComponent = /** @class */ (function () {
    function IconUserCheckComponent() {
    }
    IconUserCheckComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-user-check',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-user-check\">\n    <path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><polyline points=\"17 11 19 13 23 9\"></polyline>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUserCheckComponent;
}());
var IconUserCheck = /** @class */ (function () {
    function IconUserCheck() {
    }
    IconUserCheck.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUserCheckComponent],
                    exports: [IconUserCheckComponent]
                },] }
    ];
    return IconUserCheck;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUserMinusComponent = /** @class */ (function () {
    function IconUserMinusComponent() {
    }
    IconUserMinusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-user-minus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-user-minus\">\n    <path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"23\" y1=\"11\" x2=\"17\" y2=\"11\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUserMinusComponent;
}());
var IconUserMinus = /** @class */ (function () {
    function IconUserMinus() {
    }
    IconUserMinus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUserMinusComponent],
                    exports: [IconUserMinusComponent]
                },] }
    ];
    return IconUserMinus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUserPlusComponent = /** @class */ (function () {
    function IconUserPlusComponent() {
    }
    IconUserPlusComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-user-plus',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-user-plus\">\n    <path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"20\" y1=\"8\" x2=\"20\" y2=\"14\"></line><line x1=\"23\" y1=\"11\" x2=\"17\" y2=\"11\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUserPlusComponent;
}());
var IconUserPlus = /** @class */ (function () {
    function IconUserPlus() {
    }
    IconUserPlus.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUserPlusComponent],
                    exports: [IconUserPlusComponent]
                },] }
    ];
    return IconUserPlus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUserXComponent = /** @class */ (function () {
    function IconUserXComponent() {
    }
    IconUserXComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-user-x',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-user-x\">\n    <path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"18\" y1=\"8\" x2=\"23\" y2=\"13\"></line><line x1=\"23\" y1=\"8\" x2=\"18\" y2=\"13\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUserXComponent;
}());
var IconUserX = /** @class */ (function () {
    function IconUserX() {
    }
    IconUserX.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUserXComponent],
                    exports: [IconUserXComponent]
                },] }
    ];
    return IconUserX;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUserComponent = /** @class */ (function () {
    function IconUserComponent() {
    }
    IconUserComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-user',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-user\">\n    <path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\"></path><circle cx=\"12\" cy=\"7\" r=\"4\"></circle>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUserComponent;
}());
var IconUser = /** @class */ (function () {
    function IconUser() {
    }
    IconUser.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUserComponent],
                    exports: [IconUserComponent]
                },] }
    ];
    return IconUser;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconUsersComponent = /** @class */ (function () {
    function IconUsersComponent() {
    }
    IconUsersComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-users',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-users\">\n    <path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconUsersComponent;
}());
var IconUsers = /** @class */ (function () {
    function IconUsers() {
    }
    IconUsers.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconUsersComponent],
                    exports: [IconUsersComponent]
                },] }
    ];
    return IconUsers;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVideoOffComponent = /** @class */ (function () {
    function IconVideoOffComponent() {
    }
    IconVideoOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-video-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-video-off\">\n    <path d=\"M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVideoOffComponent;
}());
var IconVideoOff = /** @class */ (function () {
    function IconVideoOff() {
    }
    IconVideoOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVideoOffComponent],
                    exports: [IconVideoOffComponent]
                },] }
    ];
    return IconVideoOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVideoComponent = /** @class */ (function () {
    function IconVideoComponent() {
    }
    IconVideoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-video',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-video\">\n    <polygon points=\"23 7 16 12 23 17 23 7\"></polygon><rect x=\"1\" y=\"5\" width=\"15\" height=\"14\" rx=\"2\" ry=\"2\"></rect>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVideoComponent;
}());
var IconVideo = /** @class */ (function () {
    function IconVideo() {
    }
    IconVideo.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVideoComponent],
                    exports: [IconVideoComponent]
                },] }
    ];
    return IconVideo;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVoicemailComponent = /** @class */ (function () {
    function IconVoicemailComponent() {
    }
    IconVoicemailComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-voicemail',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-voicemail\">\n    <circle cx=\"5.5\" cy=\"11.5\" r=\"4.5\"></circle><circle cx=\"18.5\" cy=\"11.5\" r=\"4.5\"></circle><line x1=\"5.5\" y1=\"16\" x2=\"18.5\" y2=\"16\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVoicemailComponent;
}());
var IconVoicemail = /** @class */ (function () {
    function IconVoicemail() {
    }
    IconVoicemail.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVoicemailComponent],
                    exports: [IconVoicemailComponent]
                },] }
    ];
    return IconVoicemail;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVolume1Component = /** @class */ (function () {
    function IconVolume1Component() {
    }
    IconVolume1Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-volume-1',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-volume-1\">\n    <polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><path d=\"M15.54 8.46a5 5 0 0 1 0 7.07\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVolume1Component;
}());
var IconVolume1 = /** @class */ (function () {
    function IconVolume1() {
    }
    IconVolume1.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVolume1Component],
                    exports: [IconVolume1Component]
                },] }
    ];
    return IconVolume1;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVolume2Component = /** @class */ (function () {
    function IconVolume2Component() {
    }
    IconVolume2Component.decorators = [
        { type: Component, args: [{
                    selector: 'i-volume-2',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-volume-2\">\n    <polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><path d=\"M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVolume2Component;
}());
var IconVolume2 = /** @class */ (function () {
    function IconVolume2() {
    }
    IconVolume2.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVolume2Component],
                    exports: [IconVolume2Component]
                },] }
    ];
    return IconVolume2;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVolumeXComponent = /** @class */ (function () {
    function IconVolumeXComponent() {
    }
    IconVolumeXComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-volume-x',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-volume-x\">\n    <polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon><line x1=\"23\" y1=\"9\" x2=\"17\" y2=\"15\"></line><line x1=\"17\" y1=\"9\" x2=\"23\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVolumeXComponent;
}());
var IconVolumeX = /** @class */ (function () {
    function IconVolumeX() {
    }
    IconVolumeX.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVolumeXComponent],
                    exports: [IconVolumeXComponent]
                },] }
    ];
    return IconVolumeX;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconVolumeComponent = /** @class */ (function () {
    function IconVolumeComponent() {
    }
    IconVolumeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-volume',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-volume\">\n    <polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconVolumeComponent;
}());
var IconVolume = /** @class */ (function () {
    function IconVolume() {
    }
    IconVolume.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconVolumeComponent],
                    exports: [IconVolumeComponent]
                },] }
    ];
    return IconVolume;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconWatchComponent = /** @class */ (function () {
    function IconWatchComponent() {
    }
    IconWatchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-watch',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-watch\">\n    <circle cx=\"12\" cy=\"12\" r=\"7\"></circle><polyline points=\"12 9 12 12 13.5 13.5\"></polyline><path d=\"M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconWatchComponent;
}());
var IconWatch = /** @class */ (function () {
    function IconWatch() {
    }
    IconWatch.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconWatchComponent],
                    exports: [IconWatchComponent]
                },] }
    ];
    return IconWatch;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconWifiOffComponent = /** @class */ (function () {
    function IconWifiOffComponent() {
    }
    IconWifiOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-wifi-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-wifi-off\">\n    <line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line><path d=\"M16.72 11.06A10.94 10.94 0 0 1 19 12.55\"></path><path d=\"M5 12.55a10.94 10.94 0 0 1 5.17-2.39\"></path><path d=\"M10.71 5.05A16 16 0 0 1 22.58 9\"></path><path d=\"M1.42 9a15.91 15.91 0 0 1 4.7-2.88\"></path><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\"></path><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"20\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconWifiOffComponent;
}());
var IconWifiOff = /** @class */ (function () {
    function IconWifiOff() {
    }
    IconWifiOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconWifiOffComponent],
                    exports: [IconWifiOffComponent]
                },] }
    ];
    return IconWifiOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconWifiComponent = /** @class */ (function () {
    function IconWifiComponent() {
    }
    IconWifiComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-wifi',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-wifi\">\n    <path d=\"M5 12.55a11 11 0 0 1 14.08 0\"></path><path d=\"M1.42 9a16 16 0 0 1 21.16 0\"></path><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\"></path><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"20\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconWifiComponent;
}());
var IconWifi = /** @class */ (function () {
    function IconWifi() {
    }
    IconWifi.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconWifiComponent],
                    exports: [IconWifiComponent]
                },] }
    ];
    return IconWifi;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconWindComponent = /** @class */ (function () {
    function IconWindComponent() {
    }
    IconWindComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-wind',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-wind\">\n    <path d=\"M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2\"></path>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconWindComponent;
}());
var IconWind = /** @class */ (function () {
    function IconWind() {
    }
    IconWind.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconWindComponent],
                    exports: [IconWindComponent]
                },] }
    ];
    return IconWind;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconXCircleComponent = /** @class */ (function () {
    function IconXCircleComponent() {
    }
    IconXCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-x-circle',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-x-circle\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconXCircleComponent;
}());
var IconXCircle = /** @class */ (function () {
    function IconXCircle() {
    }
    IconXCircle.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconXCircleComponent],
                    exports: [IconXCircleComponent]
                },] }
    ];
    return IconXCircle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconXOctagonComponent = /** @class */ (function () {
    function IconXOctagonComponent() {
    }
    IconXOctagonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-x-octagon',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-x-octagon\">\n    <polygon points=\"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2\"></polygon><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconXOctagonComponent;
}());
var IconXOctagon = /** @class */ (function () {
    function IconXOctagon() {
    }
    IconXOctagon.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconXOctagonComponent],
                    exports: [IconXOctagonComponent]
                },] }
    ];
    return IconXOctagon;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconXSquareComponent = /** @class */ (function () {
    function IconXSquareComponent() {
    }
    IconXSquareComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-x-square',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-x-square\">\n    <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"9\" y1=\"9\" x2=\"15\" y2=\"15\"></line><line x1=\"15\" y1=\"9\" x2=\"9\" y2=\"15\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconXSquareComponent;
}());
var IconXSquare = /** @class */ (function () {
    function IconXSquare() {
    }
    IconXSquare.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconXSquareComponent],
                    exports: [IconXSquareComponent]
                },] }
    ];
    return IconXSquare;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconXComponent = /** @class */ (function () {
    function IconXComponent() {
    }
    IconXComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-x',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-x\">\n    <line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\"></line><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconXComponent;
}());
var IconX = /** @class */ (function () {
    function IconX() {
    }
    IconX.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconXComponent],
                    exports: [IconXComponent]
                },] }
    ];
    return IconX;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconYoutubeComponent = /** @class */ (function () {
    function IconYoutubeComponent() {
    }
    IconYoutubeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-youtube',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-youtube\">\n    <path d=\"M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z\"></path><polygon points=\"9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconYoutubeComponent;
}());
var IconYoutube = /** @class */ (function () {
    function IconYoutube() {
    }
    IconYoutube.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconYoutubeComponent],
                    exports: [IconYoutubeComponent]
                },] }
    ];
    return IconYoutube;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconZapOffComponent = /** @class */ (function () {
    function IconZapOffComponent() {
    }
    IconZapOffComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-zap-off',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-zap-off\">\n    <polyline points=\"12.41 6.75 13 2 10.57 4.92\"></polyline><polyline points=\"18.57 12.91 21 10 15.66 10\"></polyline><polyline points=\"8 8 3 14 12 14 11 22 16 16\"></polyline><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconZapOffComponent;
}());
var IconZapOff = /** @class */ (function () {
    function IconZapOff() {
    }
    IconZapOff.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconZapOffComponent],
                    exports: [IconZapOffComponent]
                },] }
    ];
    return IconZapOff;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconZapComponent = /** @class */ (function () {
    function IconZapComponent() {
    }
    IconZapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-zap',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-zap\">\n    <polygon points=\"13 2 3 14 12 14 11 22 21 10 12 10 13 2\"></polygon>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconZapComponent;
}());
var IconZap = /** @class */ (function () {
    function IconZap() {
    }
    IconZap.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconZapComponent],
                    exports: [IconZapComponent]
                },] }
    ];
    return IconZap;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconZoomInComponent = /** @class */ (function () {
    function IconZoomInComponent() {
    }
    IconZoomInComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-zoom-in',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-zoom-in\">\n    <circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line><line x1=\"11\" y1=\"8\" x2=\"11\" y2=\"14\"></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconZoomInComponent;
}());
var IconZoomIn = /** @class */ (function () {
    function IconZoomIn() {
    }
    IconZoomIn.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconZoomInComponent],
                    exports: [IconZoomInComponent]
                },] }
    ];
    return IconZoomIn;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconZoomOutComponent = /** @class */ (function () {
    function IconZoomOutComponent() {
    }
    IconZoomOutComponent.decorators = [
        { type: Component, args: [{
                    selector: 'i-zoom-out',
                    template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"feather feather-zoom-out\">\n    <circle cx=\"11\" cy=\"11\" r=\"8\"></circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"></line><line x1=\"8\" y1=\"11\" x2=\"14\" y2=\"11\"></line>\n  </svg>",
                    styles: ["\n    :host {\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2px;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  "]
                }] }
    ];
    return IconZoomOutComponent;
}());
var IconZoomOut = /** @class */ (function () {
    function IconZoomOut() {
    }
    IconZoomOut.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconZoomOutComponent],
                    exports: [IconZoomOutComponent]
                },] }
    ];
    return IconZoomOut;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { IconActivity, IconAirplay, IconAlertCircle, IconAlertOctagon, IconAlertTriangle, IconAlignCenter, IconAlignJustify, IconAlignLeft, IconAlignRight, IconAnchor, IconAperture, IconArchive, IconArrowDownCircle, IconArrowDownLeft, IconArrowDownRight, IconArrowDown, IconArrowLeftCircle, IconArrowLeft, IconArrowRightCircle, IconArrowRight, IconArrowUpCircle, IconArrowUpLeft, IconArrowUpRight, IconArrowUp, IconAtSign, IconAward, IconBarChart2, IconBarChart, IconBatteryCharging, IconBattery, IconBellOff, IconBell, IconBluetooth, IconBold, IconBookOpen, IconBook, IconBookmark, IconBox, IconBriefcase, IconCalendar, IconCameraOff, IconCamera, IconCast, IconCheckCircle, IconCheckSquare, IconCheck, IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp, IconChevronsDown, IconChevronsLeft, IconChevronsRight, IconChevronsUp, IconChrome, IconCircle, IconClipboard, IconClock, IconCloudDrizzle, IconCloudLightning, IconCloudOff, IconCloudRain, IconCloudSnow, IconCloud, IconCode, IconCodepen, IconCoffee, IconCommand, IconCompass, IconCopy, IconCornerDownLeft, IconCornerDownRight, IconCornerLeftDown, IconCornerLeftUp, IconCornerRightDown, IconCornerRightUp, IconCornerUpLeft, IconCornerUpRight, IconCpu, IconCreditCard, IconCrop, IconCrosshair, IconDatabase, IconDelete, IconDisc, IconDollarSign, IconDownloadCloud, IconDownload, IconDroplet, IconEdit2, IconEdit3, IconEdit, IconExternalLink, IconEyeOff, IconEye, IconFacebook, IconFastForward, IconFeather, IconFigma, IconFileMinus, IconFilePlus, IconFileText, IconFile, IconFilm, IconFilter, IconFlag, IconFolderMinus, IconFolderPlus, IconFolder, IconFrown, IconGift, IconGitBranch, IconGitCommit, IconGitMerge, IconGitPullRequest, IconGithub, IconGitlab, IconGlobe, IconGrid, IconHardDrive, IconHash, IconHeadphones, IconHeart, IconHelpCircle, IconHome, IconImage, IconInbox, IconInfo, IconInstagram, IconItalic, IconKey, IconLayers, IconLayout, IconLifeBuoy, IconLink2, IconLink, IconLinkedin, IconList, IconLoader, IconLock, IconLogIn, IconLogOut, IconMail, IconMapPin, IconMap, IconMaximize2, IconMaximize, IconMeh, IconMenu, IconMessageCircle, IconMessageSquare, IconMicOff, IconMic, IconMinimize2, IconMinimize, IconMinusCircle, IconMinusSquare, IconMinus, IconMonitor, IconMoon, IconMoreHorizontal, IconMoreVertical, IconMousePointer, IconMove, IconMusic, IconNavigation2, IconNavigation, IconOctagon, IconPackage, IconPaperclip, IconPauseCircle, IconPause, IconPenTool, IconPercent, IconPhoneCall, IconPhoneForwarded, IconPhoneIncoming, IconPhoneMissed, IconPhoneOff, IconPhoneOutgoing, IconPhone, IconPieChart, IconPlayCircle, IconPlay, IconPlusCircle, IconPlusSquare, IconPlus, IconPocket, IconPower, IconPrinter, IconRadio, IconRefreshCcw, IconRefreshCw, IconRepeat, IconRewind, IconRotateCcw, IconRotateCw, IconRss, IconSave, IconScissors, IconSearch, IconSend, IconServer, IconSettings, IconShare2, IconShare, IconShieldOff, IconShield, IconShoppingBag, IconShoppingCart, IconShuffle, IconSidebar, IconSkipBack, IconSkipForward, IconSlack, IconSlash, IconSliders, IconSmartphone, IconSmile, IconSpeaker, IconSquare, IconStar, IconStopCircle, IconSun, IconSunrise, IconSunset, IconTablet, IconTag, IconTarget, IconTerminal, IconThermometer, IconThumbsDown, IconThumbsUp, IconToggleLeft, IconToggleRight, IconTrash2, IconTrash, IconTrello, IconTrendingDown, IconTrendingUp, IconTriangle, IconTruck, IconTv, IconTwitter, IconType, IconUmbrella, IconUnderline, IconUnlock, IconUploadCloud, IconUpload, IconUserCheck, IconUserMinus, IconUserPlus, IconUserX, IconUser, IconUsers, IconVideoOff, IconVideo, IconVoicemail, IconVolume1, IconVolume2, IconVolumeX, IconVolume, IconWatch, IconWifiOff, IconWifi, IconWind, IconXCircle, IconXOctagon, IconXSquare, IconX, IconYoutube, IconZapOff, IconZap, IconZoomIn, IconZoomOut, IconActivityComponent as ɵa, IconAirplayComponent as ɵb, IconAlertCircleComponent as ɵc, IconAlertOctagonComponent as ɵd, IconAlertTriangleComponent as ɵe, IconAlignCenterComponent as ɵf, IconAlignJustifyComponent as ɵg, IconAlignLeftComponent as ɵh, IconAlignRightComponent as ɵi, IconAnchorComponent as ɵj, IconApertureComponent as ɵk, IconArchiveComponent as ɵl, IconArrowDownComponent as ɵp, IconArrowDownCircleComponent as ɵm, IconArrowDownLeftComponent as ɵn, IconArrowDownRightComponent as ɵo, IconArrowLeftComponent as ɵr, IconArrowLeftCircleComponent as ɵq, IconArrowRightComponent as ɵt, IconArrowRightCircleComponent as ɵs, IconArrowUpComponent as ɵx, IconArrowUpCircleComponent as ɵu, IconArrowUpLeftComponent as ɵv, IconArrowUpRightComponent as ɵw, IconAtSignComponent as ɵy, IconAwardComponent as ɵz, IconBarChartComponent as ɵbb, IconBarChart2Component as ɵba, IconBatteryComponent as ɵbd, IconBatteryChargingComponent as ɵbc, IconBellComponent as ɵbf, IconBellOffComponent as ɵbe, IconBluetoothComponent as ɵbg, IconBoldComponent as ɵbh, IconBookComponent as ɵbj, IconBookOpenComponent as ɵbi, IconBookmarkComponent as ɵbk, IconBoxComponent as ɵbl, IconBriefcaseComponent as ɵbm, IconCalendarComponent as ɵbn, IconCameraComponent as ɵbp, IconCameraOffComponent as ɵbo, IconCastComponent as ɵbq, IconCheckComponent as ɵbt, IconCheckCircleComponent as ɵbr, IconCheckSquareComponent as ɵbs, IconChevronDownComponent as ɵbu, IconChevronLeftComponent as ɵbv, IconChevronRightComponent as ɵbw, IconChevronUpComponent as ɵbx, IconChevronsDownComponent as ɵby, IconChevronsLeftComponent as ɵbz, IconChevronsRightComponent as ɵca, IconChevronsUpComponent as ɵcb, IconChromeComponent as ɵcc, IconCircleComponent as ɵcd, IconClipboardComponent as ɵce, IconClockComponent as ɵcf, IconCloudComponent as ɵcl, IconCloudDrizzleComponent as ɵcg, IconCloudLightningComponent as ɵch, IconCloudOffComponent as ɵci, IconCloudRainComponent as ɵcj, IconCloudSnowComponent as ɵck, IconCodeComponent as ɵcm, IconCodepenComponent as ɵcn, IconCoffeeComponent as ɵco, IconCommandComponent as ɵcp, IconCompassComponent as ɵcq, IconCopyComponent as ɵcr, IconCornerDownLeftComponent as ɵcs, IconCornerDownRightComponent as ɵct, IconCornerLeftDownComponent as ɵcu, IconCornerLeftUpComponent as ɵcv, IconCornerRightDownComponent as ɵcw, IconCornerRightUpComponent as ɵcx, IconCornerUpLeftComponent as ɵcy, IconCornerUpRightComponent as ɵcz, IconCpuComponent as ɵda, IconCreditCardComponent as ɵdb, IconCropComponent as ɵdc, IconCrosshairComponent as ɵdd, IconDatabaseComponent as ɵde, IconDeleteComponent as ɵdf, IconDiscComponent as ɵdg, IconDollarSignComponent as ɵdh, IconDownloadComponent as ɵdj, IconDownloadCloudComponent as ɵdi, IconDropletComponent as ɵdk, IconEditComponent as ɵdn, IconEdit2Component as ɵdl, IconEdit3Component as ɵdm, IconExternalLinkComponent as ɵdo, IconEyeComponent as ɵdq, IconEyeOffComponent as ɵdp, IconFacebookComponent as ɵdr, IconFastForwardComponent as ɵds, IconFeatherComponent as ɵdt, IconFigmaComponent as ɵdu, IconFileComponent as ɵdy, IconFileMinusComponent as ɵdv, IconFilePlusComponent as ɵdw, IconFileTextComponent as ɵdx, IconFilmComponent as ɵdz, IconFilterComponent as ɵea, IconFlagComponent as ɵeb, IconFolderComponent as ɵee, IconFolderMinusComponent as ɵec, IconFolderPlusComponent as ɵed, IconFrownComponent as ɵef, IconGiftComponent as ɵeg, IconGitBranchComponent as ɵeh, IconGitCommitComponent as ɵei, IconGitMergeComponent as ɵej, IconGitPullRequestComponent as ɵek, IconGithubComponent as ɵel, IconGitlabComponent as ɵem, IconGlobeComponent as ɵen, IconGridComponent as ɵeo, IconHardDriveComponent as ɵep, IconHashComponent as ɵeq, IconHeadphonesComponent as ɵer, IconHeartComponent as ɵes, IconHelpCircleComponent as ɵet, IconHomeComponent as ɵeu, IconImageComponent as ɵev, IconInboxComponent as ɵew, IconInfoComponent as ɵex, IconInstagramComponent as ɵey, IconItalicComponent as ɵez, IconKeyComponent as ɵfa, IconLayersComponent as ɵfb, IconLayoutComponent as ɵfc, IconLifeBuoyComponent as ɵfd, IconLinkComponent as ɵff, IconLink2Component as ɵfe, IconLinkedinComponent as ɵfg, IconListComponent as ɵfh, IconLoaderComponent as ɵfi, IconLockComponent as ɵfj, IconLogInComponent as ɵfk, IconLogOutComponent as ɵfl, IconMailComponent as ɵfm, IconMapComponent as ɵfo, IconMapPinComponent as ɵfn, IconMaximizeComponent as ɵfq, IconMaximize2Component as ɵfp, IconMehComponent as ɵfr, IconMenuComponent as ɵfs, IconMessageCircleComponent as ɵft, IconMessageSquareComponent as ɵfu, IconMicComponent as ɵfw, IconMicOffComponent as ɵfv, IconMinimizeComponent as ɵfy, IconMinimize2Component as ɵfx, IconMinusComponent as ɵgb, IconMinusCircleComponent as ɵfz, IconMinusSquareComponent as ɵga, IconMonitorComponent as ɵgc, IconMoonComponent as ɵgd, IconMoreHorizontalComponent as ɵge, IconMoreVerticalComponent as ɵgf, IconMousePointerComponent as ɵgg, IconMoveComponent as ɵgh, IconMusicComponent as ɵgi, IconNavigationComponent as ɵgk, IconNavigation2Component as ɵgj, IconOctagonComponent as ɵgl, IconPackageComponent as ɵgm, IconPaperclipComponent as ɵgn, IconPauseComponent as ɵgp, IconPauseCircleComponent as ɵgo, IconPenToolComponent as ɵgq, IconPercentComponent as ɵgr, IconPhoneComponent as ɵgy, IconPhoneCallComponent as ɵgs, IconPhoneForwardedComponent as ɵgt, IconPhoneIncomingComponent as ɵgu, IconPhoneMissedComponent as ɵgv, IconPhoneOffComponent as ɵgw, IconPhoneOutgoingComponent as ɵgx, IconPieChartComponent as ɵgz, IconPlayComponent as ɵhb, IconPlayCircleComponent as ɵha, IconPlusComponent as ɵhe, IconPlusCircleComponent as ɵhc, IconPlusSquareComponent as ɵhd, IconPocketComponent as ɵhf, IconPowerComponent as ɵhg, IconPrinterComponent as ɵhh, IconRadioComponent as ɵhi, IconRefreshCcwComponent as ɵhj, IconRefreshCwComponent as ɵhk, IconRepeatComponent as ɵhl, IconRewindComponent as ɵhm, IconRotateCcwComponent as ɵhn, IconRotateCwComponent as ɵho, IconRssComponent as ɵhp, IconSaveComponent as ɵhq, IconScissorsComponent as ɵhr, IconSearchComponent as ɵhs, IconSendComponent as ɵht, IconServerComponent as ɵhu, IconSettingsComponent as ɵhv, IconShareComponent as ɵhx, IconShare2Component as ɵhw, IconShieldComponent as ɵhz, IconShieldOffComponent as ɵhy, IconShoppingBagComponent as ɵia, IconShoppingCartComponent as ɵib, IconShuffleComponent as ɵic, IconSidebarComponent as ɵid, IconSkipBackComponent as ɵie, IconSkipForwardComponent as ɵif, IconSlackComponent as ɵig, IconSlashComponent as ɵih, IconSlidersComponent as ɵii, IconSmartphoneComponent as ɵij, IconSmileComponent as ɵik, IconSpeakerComponent as ɵil, IconSquareComponent as ɵim, IconStarComponent as ɵin, IconStopCircleComponent as ɵio, IconSunComponent as ɵip, IconSunriseComponent as ɵiq, IconSunsetComponent as ɵir, IconTabletComponent as ɵis, IconTagComponent as ɵit, IconTargetComponent as ɵiu, IconTerminalComponent as ɵiv, IconThermometerComponent as ɵiw, IconThumbsDownComponent as ɵix, IconThumbsUpComponent as ɵiy, IconToggleLeftComponent as ɵiz, IconToggleRightComponent as ɵja, IconTrashComponent as ɵjc, IconTrash2Component as ɵjb, IconTrelloComponent as ɵjd, IconTrendingDownComponent as ɵje, IconTrendingUpComponent as ɵjf, IconTriangleComponent as ɵjg, IconTruckComponent as ɵjh, IconTvComponent as ɵji, IconTwitterComponent as ɵjj, IconTypeComponent as ɵjk, IconUmbrellaComponent as ɵjl, IconUnderlineComponent as ɵjm, IconUnlockComponent as ɵjn, IconUploadComponent as ɵjp, IconUploadCloudComponent as ɵjo, IconUserComponent as ɵju, IconUserCheckComponent as ɵjq, IconUserMinusComponent as ɵjr, IconUserPlusComponent as ɵjs, IconUserXComponent as ɵjt, IconUsersComponent as ɵjv, IconVideoComponent as ɵjx, IconVideoOffComponent as ɵjw, IconVoicemailComponent as ɵjy, IconVolumeComponent as ɵkc, IconVolume1Component as ɵjz, IconVolume2Component as ɵka, IconVolumeXComponent as ɵkb, IconWatchComponent as ɵkd, IconWifiComponent as ɵkf, IconWifiOffComponent as ɵke, IconWindComponent as ɵkg, IconXComponent as ɵkk, IconXCircleComponent as ɵkh, IconXOctagonComponent as ɵki, IconXSquareComponent as ɵkj, IconYoutubeComponent as ɵkl, IconZapComponent as ɵkn, IconZapOffComponent as ɵkm, IconZoomInComponent as ɵko, IconZoomOutComponent as ɵkp };

//# sourceMappingURL=angular-feather.js.map